import React, { useEffect, useRef, useState } from 'react';
import logoMonotone from './logos/logo-monotone.svg';
import logoInverted from './logos/logo-inverted.svg';
import playButtonIcon from './Play Button.svg';
import logoColour1 from './logos/logo-colour-1.svg';
import logoColour2 from './logos/logo-colour-2.svg';
import logoColour3 from './logos/logo-colour-3.svg';
import homeStudioPhoto from './Home.jpg';
import nottingHill001 from './Notting Hill Gateway/001.jpg';
import nottingHill002 from './Notting Hill Gateway/002.jpg';
import nottingHill003 from './Notting Hill Gateway/003.jpg';
import nottingHill004 from './Notting Hill Gateway/004.png';
import nottingHill005 from './Notting Hill Gateway/005.svg';
import nottingHill006 from './Notting Hill Gateway/006.png';
import nottingHill007 from './Notting Hill Gateway/007.png';
import veniceStreet001 from './Venice Street/001.jpg';
import stratfordCross001 from './Stratford Cross/001.png';
import stratfordCross002 from './Stratford Cross/002.png';
import stratfordCross003 from './Stratford Cross/003.png';
import clavertonDown001 from './Claverton Down Masterplan/001.jpg';
import clavertonDown002 from './Claverton Down Masterplan/002.png';
import clavertonDown003 from './Claverton Down Masterplan/003.png';
import clavertonDown004 from './Claverton Down Masterplan/004.png';
import clavertonDown005 from './Claverton Down Masterplan/005.png';
import clavertonDown006 from './Claverton Down Masterplan/006.jpg';
import clavertonDown007 from './Claverton Down Masterplan/007.jpg';
import clavertonDown008 from './Claverton Down Masterplan/008.png';
import holyIsland001 from './Holy Island Woodworks/001.jpg';
import holyIsland002 from './Holy Island Woodworks/002.jpg';
import holyIsland003 from './Holy Island Woodworks/003.jpg';
import holyIsland004 from './Holy Island Woodworks/004.jpg';
import holyIsland005 from './Holy Island Woodworks/005.svg';
import marikaAlderton001 from './Marika Alderton/001.svg';
import marikaAlderton002 from './Marika Alderton/002.jpg';
import marikaAlderton003 from './Marika Alderton/003.svg';
import marikaAlderton004 from './Marika Alderton/004.svg';
import marikaAlderton005 from './Marika Alderton/005.jpg';
import domesticCommunity001 from './A Domestic Community Centre/001.jpg';
import domesticCommunity002 from './A Domestic Community Centre/002.jpg';
import domesticCommunity003 from './A Domestic Community Centre/003.jpg';
import domesticCommunity004 from './A Domestic Community Centre/004.jpg';
import domesticCommunity005 from './A Domestic Community Centre/005.png';
import glenkerryCoop001 from './Glenkerry Co op/001.jpg';
import parkCrescent001 from './Park Crescent/001.jpg';
import paddingtonHeights001 from './Paddington Heights/001.jpg';
import paddingtonHeights002 from './Paddington Heights/002.jpg';
import paddingtonHeights003 from './Paddington Heights/003.jpg';
import paddingtonHeights004 from './Paddington Heights/004.jpg';
import paddingtonHeights005 from './Paddington Heights/005.jpg';
import paddingtonHeights006 from './Paddington Heights/006.jpg';
import paddingtonHeights007 from './Paddington Heights/007.jpg';
import paddingtonHeights008 from './Paddington Heights/008.jpg';
import sydneyGardens001 from './Sydney Gardens/001.jpg';
import sydneyGardens002 from './Sydney Gardens/002.svg';
import sydneyGardens003 from './Sydney Gardens/003.jpg';
import sydneyGardens004 from './Sydney Gardens/004.jpg';
import sydneyGardens005 from './Sydney Gardens/005.jpg';
import sydneyGardens006 from './Sydney Gardens/006.jpg';
import sketchbook001 from './Sketchbook/001.jpg';
import sketchbook002 from './Sketchbook/002.jpg';
import sketchbook003 from './Sketchbook/003.jpg';
import sketchbook004 from './Sketchbook/004.jpg';
import sketchbook005 from './Sketchbook/005.jpg';
import sketchbook006 from './Sketchbook/006.jpg';
import sketchbook007 from './Sketchbook/007.jpg';
import sketchbook008 from './Sketchbook/008.jpg';
import sketchbook009 from './Sketchbook/009.jpg';
import sketchbook010 from './Sketchbook/010.jpg';
import sketchbook011 from './Sketchbook/011.jpg';
import sketchbook012 from './Sketchbook/012.jpg';
import sketchbook013 from './Sketchbook/013.jpg';
import sketchbook014 from './Sketchbook/014.jpg';
import sketchbook015 from './Sketchbook/015.jpg';
import sketchbook016 from './Sketchbook/016.jpg';
import sketchbook017 from './Sketchbook/017.jpg';
import sketchbook018 from './Sketchbook/018.jpg';
import sketchbook019 from './Sketchbook/019.jpg';
import homeVideo from './Home Video.mp4';

const COLORS = {
  coral: '#EF8368',
  green: '#5B9751',
  blue: '#889BCE',
  white: '#FFFFFF',
  black: '#111111',
  grey: '#ECECEC',
};

const SWATCH_LOGOS = {
  coral: logoColour1,
  blue: logoColour2,
  green: logoColour3,
};

const getLogoForSwatch = (swatch) => SWATCH_LOGOS[swatch] || logoColour1;

const useViewportWidth = () => {
  const [viewportWidth, setViewportWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1820
  );

  useEffect(() => {
    const updateWidth = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  return viewportWidth;
};

const PROJECTS = [
  {
    id: 1,
    title: 'Notting Hill Gateway',
    type: 'project',
    swatch: 'coral',
    coverRatio: 792 / 1224,
    cover: nottingHill005,
    description: `The development of a set of stone stairs for luxury flats in Notting Hill. This project was a dedication to a singular architectural element with a sculptural level of care and detail. Workflows combined hand drawing with geometric modelling in Rhino 8, alongside 3D printing a 1.25 scale model to fully resolve the design.`,
    images: [
      nottingHill001,
      nottingHill002,
      nottingHill003,
      nottingHill004,
      nottingHill005,
      nottingHill006,
      nottingHill007,
    ],
  },
  {
    id: 2,
    title: 'Sketch Study',
    type: 'sketch',
    swatch: 'green',
    coverRatio: 1920 / 975,
    cover: veniceStreet001,
    annotation: 'Venice streets',
    description: `A sketch of my favourite street encountered on a sightseeing visit to Venice, Italy. The area itself was relatively ordinary and away from the main tourist routes; I was drawn to the level of intricacy within an everyday setting. It represented to me how material, proportion and detail can give a place character without relying on monumentality.`,
  },
  {
    id: 3,
    title: 'Sketchbook',
    type: 'gallery',
    swatch: 'blue',
    description: `A collection of miscellaneous sketches produced over the years as I have developed as a designer. Most have no particular significance on their own: some were drawn recreationally while travelling, others quickly during meetings or simply in moments of spare time. Together, however, they reflect how important sketching is to my process. It allows me to develop ideas on paper, rationalise what I am seeing, and communicate quickly to others how I interpret a place, object or situation.`,
  },
  {
    id: 4,
    title: 'Stratford Cross',
    type: 'project',
    swatch: 'green',
    coverRatio: 1407 / 2048,
    cover: stratfordCross001,
    description: `The development of 5 high rise properties in East London. Property types include affordable housing, student accommodation alongside rent to investor property.

Hexagonal forms allow for viewpoints and balcony space on a greater number of angles, with sky podiums providing outside amenity space towards residents. A circular park is positioned in Redman Square that acts as a central hub for shared space between residents amongst a bustling area in Stratford.`,
    images: [
      stratfordCross001,
      stratfordCross002,
      stratfordCross003,
    ],
  },
  {
    id: 5,
    title: 'Sydney Gardens',
    type: 'project',
    swatch: 'coral',
    cover: sydneyGardens001,
    description: `Sydney Gardens is a dedication to the performative arts in the city of Bath. The theatre aims to capture the bustle of the market that previously existed in the once Victorian green space, simultaneously including a playful and energetic edge. The design’s whimsical composition, roof structure and organisation contribute to minimising unwanted noise, environmental and visual disturbances to theatregoers.`,
    images: [
      sydneyGardens001,
      sydneyGardens002,
      sydneyGardens003,
      sydneyGardens004,
      sydneyGardens005,
      sydneyGardens006,
    ],
  },
  {
    id: 6,
    title: 'Claverton Down Masterplan',
    type: 'project',
    swatch: 'green',
    coverRatio: 1241 / 2048,
    cover: clavertonDown008,
    description: `A master planning project involving the development of a new housing estate on a greenfield site in Claverton Down, coordinated alongside the Domestic Community Centre. 160-200 dwellings were required.

The response involved the repetition of localised neighbourhood dwellings scaling between 7 and 9 houses of varying storeys. Each unit included private garden spaces leading into a shared communal greenhouse. Individual roles of the project included planning each unit’s floor plan, material palettes, drainage systems and structure.`,
    images: [
      clavertonDown001,
      clavertonDown002,
      clavertonDown003,
      clavertonDown004,
      clavertonDown005,
      clavertonDown006,
      clavertonDown007,
      clavertonDown008,
    ],
  },
  {
    id: 7,
    title: 'Marika Alderton',
    type: 'project',
    swatch: 'blue',
    cover: marikaAlderton002,
    description: `A one week case study exploring the fundamentals of a Glen Murcutt house designed in 1994. Outcomes involved a set of plans, sections and elevations, a 1.100 timber blockwork model and an enhanced awareness in both spatial planning and environmental management. A key concept was to explore how architecture is managed in the humid and dense climatic conditions of Australia.`,
    images: [
      marikaAlderton001,
      marikaAlderton002,
      marikaAlderton003,
      marikaAlderton004,
      marikaAlderton005,
    ],
  },
  {
    id: 8,
    title: 'A Domestic Community Centre',
    type: 'project',
    swatch: 'green',
    cover: domesticCommunity001,
    description: `The development of two rammed earth buildings, alongside a surrounding park, to create a community centre on the northeast side of a greenfield site in Claverton Down.

The design looks into creating intimate spaces at a smaller scale, from what is a large, modern community centre with an array of requirements and a 600 sqm floor space. A double height multifunction hall is the primary building of the site, whilst also having smaller single height ancillary spaces that can be enjoyed by smaller groups of the community.`,
    images: [
      domesticCommunity001,
      domesticCommunity002,
      domesticCommunity003,
      domesticCommunity004,
      domesticCommunity005,
    ],
  },
  {
    id: 9,
    title: 'Holy Island Woodworks',
    type: 'project',
    swatch: 'coral',
    coverRatio: 2000 / 1014,
    cover: holyIsland001,
    description: `A dual client dwelling located on an island off the coast of Northumbria. Erected from a ruined 12x18m garden wall perimeter, the design marries a modern arrangement, complete with a woodworker’s workshop, with the historic context in a sustainable and materially frugal manner. Its composition allows for separation between a living and working space, whilst its external façades allow for a subtle identification of what defines each section. Materials and housing typology are kept to the bounds of North Eastern vernacular.`,
    images: [
      holyIsland001,
      holyIsland002,
      holyIsland003,
      holyIsland004,
      holyIsland005,
    ],
  },
  {
    id: 10,
    title: 'Glenkerry Co op',
    type: 'sketch',
    swatch: 'blue',
    cover: glenkerryCoop001,
    annotation: 'Glenkerry Co op',
    description: `Glenkerry Cooperative was one of the last major housing developments undertaken by Ernő Goldfinger, and a design that I particularly admire. I was interested in how a restrained material palette and limited ornamentation can still create a strong sense of elegance. The watchtower expresses this especially well through the positioning of the windows, the form of the concrete structure and the arrangement of the chimney flues.`,
    images: [glenkerryCoop001],
  },
  {
    id: 11,
    title: 'Park Crescent',
    type: 'sketch',
    swatch: 'coral',
    cover: parkCrescent001,
    annotation: 'Park Crescent',
    description: `Part of Park Crescent's façade was destroyed during the Second World War and later reconstructed during the 1960s to match its original appearance. I wanted to capture the seamless relationship between the surviving and rebuilt sections, while also developing a better understanding of the basic architectural principles underlying John Nash’s original design.`,
    images: [parkCrescent001],
  },
  {
    id: 12,
    title: 'Paddington Heights',
    type: 'project',
    swatch: 'blue',
    cover: paddingtonHeights002,
    description: `A 22 storey Grade II listed residential tower built in West London. Technical challenges involved poor accessibility, inadequate fire rating and poor thermal performance.
Concrete on the façade was spalling, and low level windows without sills posed a fall safety risk.

My involvement in Stage II and III work included designing potential fenestration and technical solutions that work cohesively with each other, whilst remaining sympathetic to the building’s original design. I was a core part of the design team, undertaking site visits, compiling resident feedback, and coordinating with engineers to inform technical decisions.`,
    images: [
      paddingtonHeights001,
      paddingtonHeights002,
      paddingtonHeights003,
      paddingtonHeights004,
      paddingtonHeights005,
      paddingtonHeights006,
      paddingtonHeights007,
      paddingtonHeights008,
    ],
  },
];

const SKETCHES = [
  { id: 1, src: sketchbook001, title: 'Sketch 01' },
  { id: 13, src: sketchbook013, title: 'Sketch 13' },
  { id: 5, src: sketchbook005, title: 'Sketch 05' },
  { id: 9, src: sketchbook009, title: 'Sketch 09' },
  { id: 2, src: sketchbook002, title: 'Sketch 02' },
  { id: 14, src: sketchbook014, title: 'Sketch 14' },
  { id: 7, src: sketchbook007, title: 'Sketch 07' },
  { id: 11, src: sketchbook011, title: 'Sketch 11' },
  { id: 3, src: sketchbook003, title: 'Sketch 03' },
  { id: 15, src: sketchbook015, title: 'Sketch 15' },
  { id: 6, src: sketchbook006, title: 'Sketch 06' },
  { id: 10, src: sketchbook010, title: 'Sketch 10' },
  { id: 4, src: sketchbook004, title: 'Sketch 04' },
  { id: 16, src: sketchbook016, title: 'Sketch 16' },
  { id: 8, src: sketchbook008, title: 'Sketch 08' },
  { id: 12, src: sketchbook012, title: 'Sketch 12' },
  { id: 17, src: sketchbook017, title: 'Sketch 17' },
  { id: 18, src: sketchbook018, title: 'Sketch 18' },
  { id: 19, src: sketchbook019, title: 'Sketch 19' },
];

function Placeholder({ label, dark = false, square = false }) {
  return (
    <div
      className={`placeholder ${dark ? 'placeholder-dark' : ''}`}
      style={{ aspectRatio: square ? '1 / 1' : '4 / 3' }}
    >
      <span>{label}</span>
    </div>
  );
}

function DetailPageLogo({ swatch }) {
  return (
    <div className="page-logo project-page-logo">
      <img src={getLogoForSwatch(swatch)} alt="Portfolio logo" />
    </div>
  );
}

export default function Portfolio() {
  const viewportWidth = useViewportWidth();
  const DESKTOP_MASTER_WIDTH = 1820;
  const desktopMasterScale =
    viewportWidth > 700 ? Math.min(1, viewportWidth / DESKTOP_MASTER_WIDTH) : 1;

  const [page, setPage] = useState('home');
  const [selected, setSelected] = useState(null);
  const [homeVisitCount, setHomeVisitCount] = useState(0);
  const [introStage, setIntroStage] = useState('B3');
  const [sweep, setSweep] = useState(null);
  const [loader, setLoader] = useState(null);

  useEffect(() => {
    const b4 = setTimeout(() => setIntroStage('B4'), 750);
    const b5 = setTimeout(() => setIntroStage('B5'), 1500);

    return () => {
      clearTimeout(b4);
      clearTimeout(b5);
    };
  }, []);


  const preloadImages = (sources) => Promise.all(
    sources.filter(Boolean).map((src) => new Promise((resolve) => {
      const image = new Image();
      image.onload = resolve;
      image.onerror = resolve;
      image.src = src;
      if (image.complete) resolve();
    }))
  );

  const showLoader = (kind, sources) => {
    const startedAt = Date.now();
    setLoader({ kind, status: 'visible' });

    preloadImages(sources).then(() => {
      const remaining = Math.max(0, 700 - (Date.now() - startedAt));
      window.setTimeout(() => {
        setLoader((current) =>
          current?.kind === kind ? { ...current, status: 'leaving' } : current
        );
        window.setTimeout(
          () => setLoader((current) => current?.kind === kind ? null : current),
          450
        );
      }, remaining);
    });
  };

  const restartHomeIntro = () => {
    setIntroStage('B3');
    setHomeVisitCount((count) => count + 1);
    setTimeout(() => setIntroStage('B4'), 750);
    setTimeout(() => setIntroStage('B5'), 1500);
  };

  const navigate = (nextPage) => {
    if (nextPage === page && !selected) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    setSweep({ id: Date.now() });

    if (nextPage === 'workbook') {
      showLoader('projects', PROJECTS.map((project) => project.cover));
    }

    setTimeout(() => {
      setPage(nextPage);
      setSelected(null);
      window.scrollTo({ top: 0, behavior: 'auto' });
      if (nextPage === 'home') restartHomeIntro();
    }, 330);
  };

  const handleProjectSelection = (nextSelected) => {
    if (!nextSelected) {
      showLoader('projects', PROJECTS.map((project) => project.cover));
    } else if (nextSelected.type === 'gallery') {
      showLoader('sketchbook', SKETCHES.map((sketch) => sketch.src));
    }

    setSelected(nextSelected);
    window.scrollTo({ top: 0, behavior: 'auto' });
  };

  const navSwatch = selected?.swatch || (
    page === 'home'
      ? 'coral'
      : page === 'about'
        ? 'blue'
        : 'green'
  );

  // Persistent Back control geometry.
  // Desktop: the detail box is 1240px wide in the 1820px master canvas,
  // with 34px page padding. The channel starts at the actual content edge
  // and extends to the viewport edge, so the control sits exactly midway.
  const detailContentRightDesktop = 1496 * desktopMasterScale;
  const backChannelLeft =
    viewportWidth > 700
      ? detailContentRightDesktop
      : Math.max(0, viewportWidth - 70);

  // Align with the top of the Project eyebrow/subheading line.
  // Desktop content is master-scaled; mobile has its own 64px nav/layout.
  const backControlTop =
    viewportWidth > 700
      ? 76 + 118 * desktopMasterScale
      : 182;

  return (
    <div className={`site ${
      page === 'workbook' && selected ? 'detail-view-open' : ''
    }`}>
      <style>{styles}</style>

      <header className={`nav ${page === 'home' && !selected ? 'nav-coral-white' : ''} ${page !== 'home' ? 'nav-brand-white' : ''}`} style={{ '--nav-color': COLORS[navSwatch] }}>
        <button className="brand" onClick={() => navigate('home')} aria-label="Home">
          <span
            className="brand-text"
            style={{ color: page === 'home' && !selected ? COLORS.black : COLORS.white }}
          >
            Portfolio
          </span>
        </button>

        <nav>
          {['home', 'workbook', 'about'].map((item) => (
            <button
              key={item}
              className={`${page === item && !selected ? 'active ' : ''}nav-${item}`}
              onClick={() => navigate(item)}
            >
              {item === 'workbook' ? 'projects' : item}
            </button>
          ))}
        </nav>
      </header>

      {page === 'workbook' && selected ? (
        <aside
          className="detail-back-channel"
          aria-label="Page navigation"
          style={{
            left: `${backChannelLeft}px`,
            top: `${backControlTop}px`,
          }}
        >
          <button
            type="button"
            className="detail-back-control"
            onClick={() => {
              if (selected?.type === 'gallery') {
                const detail = { handled: false };
                window.dispatchEvent(new CustomEvent('sketchbook-back', { detail }));
                if (detail.handled) return;
              }
              handleProjectSelection(null);
            }}
          >
            ← Back
          </button>
        </aside>
      ) : null}

      {sweep ? (
        <div
          key={sweep.id}
          className="section-sweep"
          onAnimationEnd={() => setSweep(null)}
          aria-hidden="true"
        />
      ) : null}

      {loader ? (
        <div
          className={`workbook-loader ${loader.status === 'leaving' ? 'is-leaving' : ''}`}
          aria-label={loader.kind === 'sketchbook' ? 'Loading sketchbook' : 'Loading projects'}
        >
          <img
            src={loader.kind === 'sketchbook' ? logoColour2 : logoColour3}
            alt=""
            aria-hidden="true"
          />
        </div>
      ) : null}

      <main className="page-transition">
        <div className={viewportWidth > 700 ? 'desktop-master-viewport' : ''}>
          <div
            className={viewportWidth > 700 ? 'desktop-master-canvas' : 'mobile-independent-canvas'}
            style={
              viewportWidth > 700
                ? {
                    transform: `scale(${desktopMasterScale})`,
                    marginBottom: `calc((1 - ${desktopMasterScale}) * -100%)`,
                  }
                : undefined
            }
          >
          {page === 'home' && !selected ? (
            <Home
              introStage={introStage}
              homeVisitCount={homeVisitCount}
              mobileTitleScale={viewportWidth <= 700 ? Math.min(1, (viewportWidth - 36) / 1180) : 1}
            />
          ) : null}
          {page === 'workbook' ? (
            <Workbook selected={selected} setSelected={handleProjectSelection} />
          ) : null}
          {page === 'about' && !selected ? <About /> : null}
          </div>
        </div>
      </main>
    </div>
  );
}

function Home({ introStage, homeVisitCount, mobileTitleScale }) {
  return (
    <section className="home">
      <div className="home-intro">
        <div className={`final-animation-layer ${
          ['B3', 'B4', 'B5'].includes(introStage) ? 'is-visible' : ''
        }`}>
          <div
            key={homeVisitCount}
            className={`final-animation-stage ${
              ['B4', 'B5'].includes(introStage) ? 'logo-moved' : ''
            } ${
              introStage === 'B5' ? 'text-revealed' : ''
            }`}
            style={
              mobileTitleScale < 1
                ? {
                    transform: `scale(${mobileTitleScale})`,
                    transformOrigin: 'center center',
                  }
                : undefined
            }
          >
            <img className="final-logo" src={logoMonotone} alt="Portfolio logo" />
            <div className="final-text-mask">
              <div className="final-name">
                <span>Wilf</span>
                <span>Edwards</span>
              </div>
            </div>
          </div>

          <button
            className={`home-scroll-cue ${introStage === 'B5' ? 'is-visible' : ''}`}
            onClick={() => document.getElementById('home-description')?.scrollIntoView({ behavior: 'smooth' })}
            aria-label="Scroll to portfolio introduction"
          >
            <span>Scroll</span>
            <span className="home-scroll-arrow" aria-hidden="true">↓</span>
          </button>
        </div>
      </div>

      <div className="home-description" id="home-description">
        <div className="home-description-grid">
          <div>
            <p className="eyebrow eyebrow-home">Architecture · Drawing · Making</p>
            <h1>Designer focused on thoughtful spaces, materials and the process of making.</h1>
            <div className="home-description-copy">
              <p>
                I am currently a second year architecture student at the University of Bath, having worked with AHMM, Atomik Architecture and the Savills Design Department.
              </p>
              <p>
                Understanding how a design relates to its context, whether cultural, historical, or environmental, is a fundamental part of my approach. Designing in London has shown me that we are now in an era of refining rather than reinventing, and that reshaping existing structures is an important aspect of contemporary practice.
              </p>
              <p>
                I enjoy using physical processes as I design. I use my sketchbook regularly to evolve my projects in a meaningful way, and handmade models have often helped me communicate my schemes to clients or other design teams.
              </p>
            </div>
          </div>

          <div className="home-models-placeholder">
            <img
              className="home-studio-photo"
              src={homeStudioPhoto}
              alt="Working at a studio desk"
            />
          </div>
        </div>
      </div>

      <div className="home-footer-logo">
        <img src={logoColour1} alt="Portfolio logo" />
      </div>
    </section>
  );
}

function Workbook({ selected, setSelected }) {
  useEffect(() => {
    if (selected) window.scrollTo({ top: 0, behavior: 'auto' });
  }, [selected]);

  const projectsById = Object.fromEntries(PROJECTS.map((project) => [project.id, project]));

  if (selected?.type === 'project') {
    return <ProjectDetail project={selected} />;
  }

  if (selected?.type === 'sketch') {
    return <SketchDetail sketch={selected} />;
  }

  if (selected?.type === 'gallery') {
    return <SketchGallery />;
  }

  const renderProject = (project) => (
    <button
      key={project.id}
      className={`project-tile project-id-${project.id} ${project.id === 2 ? 'venice-study-tile' : ''} ${
        project.id === 3 ? 'sketchbook-tile' : ''
      }`}
      style={{ '--cover-ratio': project.coverRatio || 1 }}
      onClick={() => setSelected(project)}
    >
      {project.cover ? (
        <img
          className="project-cover-image"
          src={project.cover}
          alt={`${project.title} cover`}
        />
      ) : (
        <div className="sketchbook-tile-face">
          <span className="sketchbook-blue-band" aria-hidden="true" />
          <span className="sketchbook-title">Sketchbook</span>
        </div>
      )}
      <div className="tile-overlay"><span>{project.title}</span></div>
    </button>
  );

  return (
    <section className="workbook page-wrap">
      <div className="section-heading">
        <p className="eyebrow eyebrow-workbook">Selected work</p>
        <h1>Projects</h1>
        <p className="projects-subheading">A collection of my most recent work. Click on images to view projects in further detail.</p>
      </div>

      <div className="project-grid">
        <div className="project-column">
          {renderProject(projectsById[12])}
          {renderProject(projectsById[11])}
          {renderProject(projectsById[7])}
          {renderProject(projectsById[5])}
          {renderProject(projectsById[10])}
        </div>

        <div className="project-column">
          {renderProject(projectsById[2])}
          {renderProject(projectsById[6])}
          {renderProject(projectsById[4])}
          {renderProject(projectsById[3])}
        </div>

        <div className="project-column">
          {renderProject(projectsById[9])}
          {renderProject(projectsById[8])}
          {renderProject(projectsById[1])}
        </div>
      </div>

      <div className="page-logo">
        <img src={logoColour3} alt="Portfolio logo" />
      </div>
    </section>
  );
}


const MOBILE_PROJECT_TITLE_BREAKS = {
  'Notting Hill Gateway': ['Notting Hill', 'Gateway'],
  'Claverton Down Masterplan': ['Claverton Down', 'Masterplan'],
  'Holy Island Woodworks': ['Holy Island', 'Woodworks'],
  'A Domestic Community Centre': ['A Domestic', 'Community Centre'],
  'Paddington Heights': ['Paddington', 'Heights'],
};

function ProjectTitle({ title }) {
  const parts = MOBILE_PROJECT_TITLE_BREAKS[title];

  if (!parts) {
    return <>{title}</>;
  }

  return (
    <>
      <span className="project-title-desktop">{title}</span>
      <span className="project-title-mobile">
        {parts.map((part, index) => (
          <React.Fragment key={`${title}-${index}`}>
            {index > 0 ? <br /> : null}
            {part}
          </React.Fragment>
        ))}
      </span>
    </>
  );
}

function ProjectDetail({ project }) {
  const viewportWidth = useViewportWidth();
  const PROJECT_MASTER_WIDTH = 1240;
  const projectImageScale =
    viewportWidth <= 700
      ? Math.min(1, Math.max(0.1, (viewportWidth - 88) / PROJECT_MASTER_WIDTH))
      : 1;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });

    const cells = Array.from(document.querySelectorAll('.detail-image-cell'));

    if (!('IntersectionObserver' in window)) {
      cells.forEach((cell) => cell.classList.add('is-visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    cells.forEach((cell) => observer.observe(cell));
    return () => observer.disconnect();
  }, [project]);

  const isNottingHill = project.title === 'Notting Hill Gateway';
  const isStratfordCross = project.title === 'Stratford Cross';
  const isClavertonDown = project.title === 'Claverton Down Masterplan';
  const isHolyIsland = project.title === 'Holy Island Woodworks';
  const isMarikaAlderton = project.title === 'Marika Alderton';
  const isDomesticCommunity = project.title === 'A Domestic Community Centre';
  const isPaddingtonHeights = project.title === 'Paddington Heights';
  const isSydneyGardens = project.title === 'Sydney Gardens';
  const accentColor = COLORS[project.swatch] || COLORS.coral;

  return (
    <section
      className={`page-wrap detail ${isNottingHill ? 'notting-hill-detail' : ''} ${isStratfordCross ? 'stratford-cross-detail' : ''} ${isClavertonDown ? 'claverton-down-detail' : ''} ${isHolyIsland ? 'holy-island-detail' : ''} ${isMarikaAlderton ? 'marika-mask-detail' : ''} ${isDomesticCommunity ? 'domestic-community-detail' : ''} ${isPaddingtonHeights ? 'paddington-heights-detail' : ''} ${isSydneyGardens ? 'sydney-gardens-detail' : ''}`}
      style={{ '--accent-color': accentColor }}
    >
      <div className="detail-intro">
        <p className="eyebrow project-eyebrow">Project</p>
        <h1 className="project-detail-title"><ProjectTitle title={project.title} /></h1>
        {(project.description || 'Placeholder project text.')
          .split(/\n\s*\n/)
          .map((paragraph, index) => (
            <p key={`description-${index}`}>{paragraph}</p>
          ))}
      </div>

      <div
        className="project-image-master-shell"
        style={
          viewportWidth <= 700
            ? {
                width: `${PROJECT_MASTER_WIDTH}px`,
                zoom: projectImageScale,
              }
            : undefined
        }
      >
      {isNottingHill ? (
        <div className="detail-images notting-hill-layout">
          <div className="nh-column nh-column-left">
            <div className="detail-image-cell nh-image-001">
              <img src={project.images[0]} alt={`${project.title} 001`} />
            </div>
            <div className="detail-image-cell nh-image-002">
              <img src={project.images[1]} alt={`${project.title} 002`} />
            </div>
            <div className="detail-image-cell nh-image-003">
              <img src={project.images[2]} alt={`${project.title} 003`} />
            </div>
            <div className="detail-image-cell nh-image-004">
              <img src={project.images[3]} alt={`${project.title} 004`} />
            </div>
          </div>

          <div className="nh-column nh-column-right">
            <div className="detail-image-cell nh-image-005">
              <img src={project.images[4]} alt={`${project.title} 005`} />
            </div>
            <div className="detail-image-cell nh-image-006">
              <img src={project.images[5]} alt={`${project.title} 006`} />
            </div>
            <div className="detail-image-cell nh-image-007">
              <img src={project.images[6]} alt={`${project.title} 007`} />
            </div>
          </div>
        </div>
      ) : isStratfordCross ? (
        <div className="detail-images stratford-cross-layout">
          <div className="detail-image-cell sc-image-001">
            <img src={project.images[0]} alt={`${project.title} 001`} />
          </div>
          <div className="detail-image-cell sc-image-002">
            <img src={project.images[1]} alt={`${project.title} 002`} />
          </div>
          <div className="detail-image-cell sc-image-003">
            <img src={project.images[2]} alt={`${project.title} 003`} />
          </div>
        </div>
      ) : isClavertonDown ? (
        <div className="detail-images claverton-down-layout">
          <div className="claverton-top-layout">
            <div className="claverton-left-stack">
              <div className="detail-image-cell cd-image-001">
                <img src={project.images[0]} alt={`${project.title} 001`} />
              </div>

              <div className="claverton-detail-strip">
                {project.images.slice(1, 5).map((image, index) => (
                  <div key={image} className={`detail-image-cell cd-image-00${index + 2}`}>
                    <img src={image} alt={`${project.title} ${String(index + 2).padStart(3, '0')}`} />
                  </div>
                ))}
              </div>
            </div>

            <div className="detail-image-cell cd-image-008">
              <img src={project.images[7]} alt={`${project.title} 008`} />
            </div>
          </div>

          <div className="detail-image-cell cd-image-006">
            <img src={project.images[5]} alt={`${project.title} 006`} />
          </div>

          <div className="detail-image-cell cd-image-007">
            <img src={project.images[6]} alt={`${project.title} 007`} />
          </div>
        </div>

) : isHolyIsland ? (
  <div className="detail-images holy-island-layout">
    {[0, [2, 4], [1, 3]].map((row, rowIndex) =>
      Array.isArray(row) ? (
        <div className="holy-island-row" key={rowIndex}>
          {row.map((imageIndex) => (
            <div className={`detail-image-cell hi-image-00${imageIndex + 1}`} key={imageIndex}>
              <img src={project.images[imageIndex]} alt={`${project.title} ${String(imageIndex + 1).padStart(3, '0')}`} />
            </div>
          ))}
        </div>
      ) : (
        <div className="detail-image-cell hi-image-001" key={row}>
          <img src={project.images[row]} alt={`${project.title} 001`} />
        </div>
      )
    )}
  </div>
) : isMarikaAlderton ? (
  <div className="detail-images marika-mask-layout">
    <div className="marika-mask-top">
      <div className="detail-image-cell marika-mask-001">
        <img src={project.images[0]} alt={`${project.title} 001`} />
      </div>

      <div className="marika-mask-right">
        <div className="detail-image-cell marika-mask-003">
          <img src={project.images[2]} alt={`${project.title} 003`} />
        </div>
        <div className="detail-image-cell marika-mask-004">
          <img src={project.images[3]} alt={`${project.title} 004`} />
        </div>
        <div className="detail-image-cell marika-mask-005">
          <img src={project.images[4]} alt={`${project.title} 005`} />
        </div>
      </div>
    </div>

    <div className="detail-image-cell marika-mask-002">
      <img src={project.images[1]} alt={`${project.title} 002`} />
    </div>
  </div>
) : isDomesticCommunity ? (
  <div className="detail-images domestic-community-layout">
    <div className="domestic-community-top-layout">
      <div className="detail-image-cell dc-image-001">
        <img src={project.images[0]} alt={`${project.title} 001`} />
      </div>
      <div className="domestic-community-right-stack">
        <div className="detail-image-cell dc-image-004">
          <img src={project.images[3]} alt={`${project.title} 004`} />
        </div>
        <div className="detail-image-cell dc-image-005">
          <img src={project.images[4]} alt={`${project.title} 005`} />
        </div>
      </div>
    </div>
    <div className="detail-image-cell dc-image-002">
      <img src={project.images[1]} alt={`${project.title} 002`} />
    </div>
    <div className="detail-image-cell dc-image-003">
      <img src={project.images[2]} alt={`${project.title} 003`} />
    </div>
  </div>
) : isSydneyGardens ? (
  <div className="detail-images sydney-gardens-layout">
    <div className="detail-image-cell sg-image-001">
      <img src={project.images[0]} alt={`${project.title} 001`} />
    </div>
    <div className="sydney-middle-row">
      <div className="detail-image-cell sg-image-002">
        <img src={project.images[1]} alt={`${project.title} 002`} />
      </div>
      <div className="sydney-right-stack">
        <div className="detail-image-cell sg-image-004">
          <img src={project.images[3]} alt={`${project.title} 004`} />
        </div>
        <div className="detail-image-cell sg-image-005">
          <img src={project.images[4]} alt={`${project.title} 005`} />
        </div>
      </div>
    </div>
    <div className="sydney-bottom-row">
      <div className="detail-image-cell sg-image-003">
        <img src={project.images[2]} alt={`${project.title} 003`} />
      </div>
      <div className="detail-image-cell sg-image-006">
        <img src={project.images[5]} alt={`${project.title} 006`} />
      </div>
    </div>
  </div>
) : isPaddingtonHeights ? (
  <div className="detail-images paddington-heights-layout">
    <div className="paddington-left-block">
      <div className="paddington-top-row">
        <div className="detail-image-cell ph-image-001">
          <img src={project.images[0]} alt={`${project.title} 001`} />
        </div>
        <div className="detail-image-cell ph-image-003">
          <img src={project.images[2]} alt={`${project.title} 003`} />
        </div>
      </div>
      <div className="detail-image-cell ph-image-002">
        <img src={project.images[1]} alt={`${project.title} 002`} />
      </div>
    </div>

    <div className="paddington-right-stack">
      {project.images.slice(3).map((image, index) => (
        <div className={`detail-image-cell ph-image-00${index + 4}`} key={image}>
          <img src={image} alt={`${project.title} ${String(index + 4).padStart(3, '0')}`} />
        </div>
      ))}
    </div>
  </div>
) : (
  <div className="detail-images">
          {project.images.map((image, index) => (
            <div key={image} className={`detail-image-cell detail-image-cell-${index + 1}`}>
              <img src={image} alt={`${project.title} ${index + 1}`} />
            </div>
          ))}
        </div>
      )}
      </div>

      <DetailPageLogo swatch={project.swatch} />
    </section>
  );
}

function SketchDetail({ sketch }) {
  const accentColor = COLORS[sketch.swatch] || COLORS.blue;
  const sketchImage = sketch.images?.[0] || sketch.cover || veniceStreet001;
  const sketchCaption = sketch.annotation || sketch.title;

  return (
    <section className="page-wrap detail sketch-detail venice-sketch-detail" style={{ '--accent-color': accentColor }}>

      <div className="venice-sketch-frame">
        <img
          src={sketchImage}
          alt={sketch.title}
        />
      </div>

      <div
        className={`venice-sketch-caption ${
          sketch.title === 'Park Crescent' ? 'park-crescent-caption' : ''
        }`}
      >
        <span className="venice-blue-swatch" aria-hidden="true" />
        <p>{sketch.description || sketchCaption}</p>
      </div>

      <DetailPageLogo swatch={sketch.swatch} />
    </section>
  );
}

function SketchGallery() {
  const [activeSketch, setActiveSketch] = useState(null);
  const sketchbookScrollRef = useRef(0);

  const openSketch = (sketch) => {
    sketchbookScrollRef.current = window.scrollY;
    setActiveSketch(sketch);
    requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'auto' }));
  };

  const closeSketch = () => {
    setActiveSketch(null);
    requestAnimationFrame(() =>
      window.scrollTo({ top: sketchbookScrollRef.current, behavior: 'auto' })
    );
  };

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape' && activeSketch) closeSketch();
    };

    const onSketchbookBack = (event) => {
      if (!activeSketch) return;
      if (event.detail) event.detail.handled = true;
      closeSketch();
    };

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('sketchbook-back', onSketchbookBack);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('sketchbook-back', onSketchbookBack);
    };
  }, [activeSketch]);

  if (activeSketch) {
    return (
      <section className="sketchbook-single-page" aria-label={activeSketch.title}>
        <div className="sketchbook-single-frame">
          <img src={activeSketch.src} alt={activeSketch.title} />
        </div>
      </section>
    );
  }

  return (
    <section className="page-wrap gallery sketchbook-page">
      <div className="detail-intro">
        <p className="eyebrow project-eyebrow">Project</p>
        <h1 className="project-detail-title">Sketchbook</h1>
        <p>A collection of miscellaneous sketches produced over the years as I have developed as a designer. Most have no particular significance on their own: some were drawn recreationally while travelling, others quickly during meetings or simply in moments of spare time. Together, however, they reflect how important sketching is to my process. It allows me to develop ideas on paper, rationalise what I am seeing, and communicate quickly to others how I interpret a place, object or situation.</p>
      </div>

      <div className="sketch-grid">
        {SKETCHES.map((sketch) => (
          <button
            type="button"
            className="sketch-item"
            key={sketch.id}
            onClick={() => openSketch(sketch)}
            aria-label={`Open ${sketch.title}`}
          >
            <img src={sketch.src} alt={sketch.title} />
          </button>
        ))}
      </div>

      <DetailPageLogo swatch="blue" />
    </section>
  );
}

function About() {
  const videoRef = useRef(null);
  const videoFadeRef = useRef(null);
  const [showPlayButton, setShowPlayButton] = useState(false);
  const [isPlayButtonFading, setIsPlayButtonFading] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;

    const fadeLayer = videoFadeRef.current;
    let animationFrame;
    const fadeDuration = 1.5;

    const startVideo = () => {
      if (fadeLayer) {
        fadeLayer.style.transition = 'none';
        fadeLayer.style.opacity = '0';
        requestAnimationFrame(() => {
          fadeLayer.style.transition = `opacity ${fadeDuration}s linear`;
        });
      }

      video.currentTime = 0;
      setShowPlayButton(false);
      setIsPlayButtonFading(false);
      video.play().catch(() => setShowPlayButton(true));
    };

    const watchEndFade = () => {
      if (
        fadeLayer &&
        Number.isFinite(video.duration) &&
        video.duration > 0 &&
        video.duration - video.currentTime <= fadeDuration
      ) {
        fadeLayer.style.opacity = '1';
      }
      animationFrame = requestAnimationFrame(watchEndFade);
    };

    const finishVideo = () => {
      cancelAnimationFrame(animationFrame);
      if (fadeLayer) {
        fadeLayer.style.transition = 'none';
        fadeLayer.style.opacity = '1';
      }
      video.pause();
      video.currentTime = 0;
      setIsPlayButtonFading(false);
      setShowPlayButton(true);
    };

    const handlePlay = () => {
      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(watchEndFade);
    };

    if (video.readyState >= 2) {
      startVideo();
    } else {
      video.addEventListener('loadeddata', startVideo, { once: true });
    }

    video.addEventListener('play', handlePlay);
    video.addEventListener('ended', finishVideo);

    return () => {
      cancelAnimationFrame(animationFrame);
      video.removeEventListener('loadeddata', startVideo);
      video.removeEventListener('play', handlePlay);
      video.removeEventListener('ended', finishVideo);
    };
  }, []);

  const replayVideo = () => {
    const video = videoRef.current;
    const fadeLayer = videoFadeRef.current;
    if (!video) return;

    setIsPlayButtonFading(true);

    if (fadeLayer) {
      fadeLayer.style.transition = 'opacity .32s ease';
      fadeLayer.style.opacity = '0';
    }

    video.play()
      .then(() => {
        window.setTimeout(() => {
          setShowPlayButton(false);
          setIsPlayButtonFading(false);
          if (fadeLayer) fadeLayer.style.transition = 'opacity 1.5s linear';
        }, 320);
      })
      .catch(() => {
        setIsPlayButtonFading(false);
        setShowPlayButton(true);
      });
  };

  return (
    <section className="about">
      <div className="about-image">
        <div className="about-video-frame">
          <video
            ref={videoRef}
            src={homeVideo}
            muted
            playsInline
            preload="auto"
            aria-label="Portfolio studio film"
          />
          <img
            className="about-video-logo"
            src={logoInverted}
            alt=""
            aria-hidden="true"
          />
          <div
            ref={videoFadeRef}
            className="about-video-white-fade"
            aria-hidden="true"
          />
          {showPlayButton ? (
            <button
              type="button"
              className={`about-video-play ${isPlayButtonFading ? 'is-fading' : ''}`}
              onClick={replayVideo}
              aria-label="Play studio film"
            >
              <img
                className="about-video-play-icon"
                src={playButtonIcon}
                alt=""
                aria-hidden="true"
              />
            </button>
          ) : null}
        </div>
      </div>

      <div className="about-copy">
        <h1 className="about-page-title">About</h1>
        <p className="contact-intro">
          I welcome any engagement within the architectural community. Enquiries regarding networking, recent projects, or requests for general information can be made via the details below:
        </p>

        <div className="about-columns">
          <div>
            <h2 className="contact-heading-blue">Contact</h2>
            <p>Email: we271@bath.ac.uk</p>
            <p>Phone Number: +44(0) 7864 841739</p>
            <p>LinkedIn: www.linkedin.com/in/william-edwards</p>
          </div>
        </div>
      </div>

      <div className="page-logo page-logo-about">
        <img src={logoColour2} alt="Portfolio logo" />
      </div>
    </section>
  );
}

const styles = `

  @font-face {
    font-family: "Univers Light";
    src: url("/fonts/UniversLTCYR-45Light.otf") format("opentype");
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: "Univers Roman";
    src: url("/fonts/UniversLTPro-55Roman.otf") format("opentype");
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: "Univers Bold";
    src: url("/fonts/UniversLTCYR-65Bold.otf") format("opentype");
    font-weight: 700;
    font-style: normal;
  }
  *{ box-sizing: border-box; }
  .site{ --content-gap: 14px; }
  html{ scroll-behavior: smooth; }
  body{ margin: 0; background: ${COLORS.white}; color: ${COLORS.black}; }
  button, input, textarea, select{ font-family: "Univers Light"; }

  .site{
    min-height: 100vh;
    font-family: "Univers Light";
    background: ${COLORS.white};
  }

  .nav{
    position: fixed;
    inset: 0 0 auto 0;
    z-index: 20;
    height: 76px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 34px;
    background: var(--nav-color, ${COLORS.green});
    color: ${COLORS.black};
    border-bottom: 1px solid rgba(255,255,255,.45);
  }

  .nav.nav-coral-white{
    background: ${COLORS.white};
    color: ${COLORS.black};
    border-bottom-color: rgba(0,0,0,.12);
  }

  .nav.nav-coral-white .brand, .nav.nav-coral-white .brand-text, .nav.nav-coral-white nav button, .nav.nav-coral-white nav button:hover, .nav.nav-coral-white nav button.active{
    color: ${COLORS.black};
  }

  .nav.nav-coral-white nav button:hover, .nav.nav-coral-white nav button.active{
    border-bottom-color: ${COLORS.black};
  }

  .brand{
    width: 112px;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
  }

  .brand-text{
    font-family: "Univers Roman";
    display: block;
    font-size: 14px;
    letter-spacing: .04em;
    text-transform: none;
  }

  .intro-logo{
    height: calc(100% - 145.6px);
    width: auto;
    max-width: 1674.4px;
    max-height: 84vh;
    object-fit: contain;
  }

  .page-logo{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 70px;
    padding: 30px 0 10px;
  }

  .page-logo img{
    width: 46px;
    height: auto;
    display: block;
  }

  .home-footer-logo{
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 70px;
    padding: 30px 0 10px;
    background: ${COLORS.white};
  }

  .home-footer-logo img{
    width: 46px;
    height: auto;
    display: block;
  }

  .about{
    position: relative;
    padding-bottom: 110px;
  }

  .page-logo-about{
    position: absolute;
    left: 50%;
    bottom: 24px;
    transform: translateX(-50%);
    margin: 0;
    padding: 0;
  }

  .project-page-logo{
    margin-top: 56px;
    padding: 24px 0 0;
  }

  .nav nav{ display: flex; gap: 30px; }
  .nav nav button{
    font-family: "Univers Light";
    font-weight: 300;
    border: 0;
    background: transparent;
    padding: 8px 0;
    text-transform: none;
    cursor: pointer;
    font-size: 14px;
    letter-spacing: .04em;
    border-bottom: 1px solid transparent;
  }

  .nav nav button, .nav nav button:hover, .nav nav button.active{
    color: ${COLORS.white};
  }

  .nav nav button:hover, .nav nav button.active{
    border-bottom-color: ${COLORS.white};
  }

  .nav nav button.active{
    font-family: "Univers Light";
    font-weight: 300;
  }

  /* Hide any scroll/progress widgets if present. */
  .scroll-progress, .scroll-indicator, .page-progress, .reading-progress, [data-scroll-indicator], [data-reading-progress], [aria-label="Scroll progress"]{
    display: none !important;
  }

  main{ padding-top: 0; }

  .page-transition{
    padding-top: 76px;
  }

  .section-sweep{
    position: fixed;
    z-index: 19;
    top: 76px;
    left: 0;
    width: 1820px;
    height: calc(100vh - 76px);
    background: ${COLORS.white};
    pointer-events: none;
    transform: translateX(-101%);
    animation: sectionSweep 0.72s cubic-bezier(.76, 0, .24, 1) forwards;
  }

  @keyframes sectionSweep {
    0% { transform: translateX(-101%); }
    46% { transform: translateX(0); }
    54% { transform: translateX(0); }
    100% { transform: translateX(101%); }
  }

  .home{
    background: ${COLORS.white};
  }

  .home-intro{
    position: relative;
    height: calc(100vh - 76px);
    min-height: 640px;
    overflow: hidden;
    background: ${COLORS.white};
  }

  .home-opening-black .home-intro{
    background: ${COLORS.black};
  }

  .home-opening-black .opening-logo-layer, .home-opening-black .video-layer-clean{
    background: ${COLORS.black};
  }

  .opening-logo-layer, .video-layer-clean, .final-animation-layer{
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    opacity: 0;
    pointer-events: none;
  }

  .opening-logo-layer, .video-layer-clean{
    transition: opacity 0.8s ease;
  }

  .final-animation-layer{
    transition: opacity 0.8s ease;
  }

  .opening-logo-layer.is-visible, .video-layer-clean.is-visible, .final-animation-layer.is-visible{
    opacity: 1;
  }

  .stage-logo, .final-logo{
    height: min(72vh, 620px);
    width: auto;
    max-width: 1674.4px;
    object-fit: contain;
  }

  .video-layer-clean{
    padding: clamp(20px, 54.6px, 48px);
    background: inherit;
  }

  .home-video-frame{
    width: min(1674.4px, 810px);
    height: min(calc(100vh - 104px), 1440px);
    max-width: calc((100vh - 104px) * 9 / 16);
    aspect-ratio: 9 / 16;
    overflow: hidden;
    background: ${COLORS.black};
  }

  .final-animation-stage{
    --logo-height: min(72vh, 620px);
    --name-gap: clamp(18px, 36.4px, 36px);
    position: relative;
    width: min(1180px, 1674.4px);
    height: var(--logo-height);
  }

  .final-logo{
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    transform: translate(-50%, -50%);
    transition: transform 0.75s cubic-bezier(.22,.61,.36,1);
  }

  .final-animation-stage.logo-moved .final-logo{
    transform: translate(-88%, -50%);
  }

  .final-text-mask{
    position: absolute;
    top: 31%;
    bottom: 31%;
    left: 50%;
    right: 0;
    overflow: hidden;
  }

  .final-name{
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding-left: var(--name-gap);
    font-size: clamp(58px, 145.6px, 138px);
    line-height: 0.74;
    letter-spacing: -0.045em;
    white-space: nowrap;
    transform: translateX(-100%);
    transition: transform 0.75s cubic-bezier(.22,.61,.36,1);
  }

  .final-animation-stage.text-revealed .final-name{
    transform: translateX(0);
  }

  .home-scroll-cue{
    position: absolute;
    left: 50%;
    bottom: 24px;
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    border: 0;
    padding: 8px 12px;
    background: transparent;
    color: ${COLORS.black};
    font-family: "Univers Light";
    font-size: 11px;
    letter-spacing: .04em;
    cursor: pointer;
    opacity: 0;
    transform: translate(-50%, 10px);
    transition: opacity .45s ease, transform .45s ease;
    pointer-events: none;
  }

  .home-scroll-cue.is-visible{
    opacity: 1;
    transform: translate(-50%, 0);
    pointer-events: auto;
  }

  .home-scroll-arrow{
    font-size: 24px;
    line-height: .8;
    animation: home-scroll-bounce 1.5s ease-in-out infinite;
  }

  @keyframes home-scroll-bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(5px); }
  }

  .video-layer{ padding: 72.8px; background: ${COLORS.white}; }
  .video-placeholder, .home-video-frame video{
    width: 100%;
    height: 100%;
    display: block;
  }

  .video-placeholder{
    display: grid;
    place-items: center;
    background:
      linear-gradient(135deg, rgba(136,155,206,.25), rgba(239,131,104,.16)),
      ${COLORS.black};
    color: white;
    text-align: center;
    text-transform: none;
    letter-spacing: .04em;
    font-size: 12px;
  }

  .home-video-frame video{
    object-fit: cover;
    object-position: center;
  }

  .home-description{
    min-height: auto;
    display: flex;
    align-items: center;
    padding: 127.4px 182px 0;
    background: ${COLORS.white};
  }

  .home-description-grid{
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    gap: 127.4px;
    align-items: stretch;
  }

  .home-description-grid > div:first-child{
    max-width: 820px;
  }

  .home-models-placeholder{
    min-width: 0;
    min-height: 0;
    height: 100%;
    align-self: stretch;
    overflow: hidden;
  }

  .home-studio-photo{
    width: 100%;
    height: 100%;
    min-height: 0;
    display: block;
    object-fit: cover;
    object-position: left center;
  }

  .home-description h1{
    font-family: "Univers Roman";
    margin: 14px 0 24px;
    font-size: clamp(38px, 94.64px, 78px);
    line-height: 1.04;
    font-weight: 400;
    letter-spacing: -.035em;
  }

  .home-description-copy{
    max-width: 600px;
  }

  .home-description-copy p{
    margin: 0 0 16px;
  }

  .home-description-copy p:last-child{
    margin-bottom: 0;
  }

  .home-description p:last-child{
    max-width: 600px;
    font-size: 17px;
    line-height: 1.65;
  }

  .eyebrow{
    font-family: "Univers Bold";
    font-weight: 700;
    margin: 0;
    text-transform: none;
    letter-spacing: .04em;
    font-size: 11px;
  }

  .eyebrow-home{ color: ${COLORS.coral}; }
  .eyebrow-workbook, .eyebrow-contact{
    font-family: "Univers Bold";
    font-weight: 700;
  }

  .eyebrow-workbook{ color: ${COLORS.green}; }
  .eyebrow-contact{ color: ${COLORS.blue}; }

  .page-wrap{ padding: 64px 34px 90px; }
  .section-heading{ margin-bottom: 44px; max-width: 640px; }
  .section-heading h1, .detail-intro h1, .about-copy h1{
    font-family: "Univers Roman";
    margin: 10px 0 18px;
    font-size: clamp(42px, 91px, 70px);
    line-height: 1;
    font-weight: 400;
    letter-spacing: -.035em;
  }

  .section-heading p:last-child, .detail-intro p:last-child, .about-copy > p{
    font-size: 16px;
    line-height: 1.65;
  }

  .project-grid{
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: var(--content-gap);
    align-items: stretch;
  }

  .project-column{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: var(--content-gap);
    min-width: 0;
    align-self: stretch;
  }

  .workbook .project-tile, .workbook .project-cover-image, .workbook .project-tile .placeholder{
    border: none;
    outline: none;
    box-shadow: none;
  }

  .project-tile{
    position: relative;
    display: block;
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    overflow: hidden;
    cursor: pointer;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .project-tile:has(.project-cover-image), .venice-study-tile:has(.project-cover-image){
    width: 100%;
    height: auto;
    aspect-ratio: auto;
  }

  .project-cover-image, .venice-study-tile .project-cover-image{
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }

  .workbook .project-tile.sketchbook-tile{
    position: relative;
    order: 999;
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    padding: 0;
    overflow: hidden;
    background: ${COLORS.white};
    cursor: pointer;
  }

  .sketchbook-tile-face{
    position: relative;
    width: 100%;
    height: 100%;
    display: grid;
    place-items: center;
    overflow: hidden;
    background: ${COLORS.white};
    color: ${COLORS.blue};
    transition:
      background .3s ease,
      color .3s ease,
      transform .3s ease;
  }

  .sketchbook-title{
    position: relative;
    z-index: 2;
    font-family: "Univers Light";
    font-weight: 400;
    font-size: clamp(24px, 54.6px, 48px);
    line-height: 1;
    text-align: center;
  }

  .sketchbook-blue-band{
    position: absolute;
    inset: 0 auto 0 0;
    width: 12px;
    background: ${COLORS.blue};
    transition: width .3s ease, background .3s ease;
  }

  .sketchbook-blue-swatch{
    position: absolute;
    top: 14px;
    right: 14px;
    width: 28px;
    height: 28px;
    background: ${COLORS.blue};
  }

  .sketchbook-coral-swatch{
    position: absolute;
    left: 26px;
    bottom: 18px;
    width: 54px;
    height: 6px;
    background: ${COLORS.coral};
  }

  .sketchbook-arrow{
    position: absolute;
    right: 18px;
    bottom: 14px;
    z-index: 2;
    font-family: "Univers Light";
    font-size: 24px;
    line-height: 1;
    color: ${COLORS.black};
    transition: color .3s ease, transform .3s ease;
  }

  .sketchbook-tile:hover .sketchbook-tile-face{
    background: ${COLORS.blue};
    color: ${COLORS.white};
    transform: translateY(-2px);
  }

  .sketchbook-tile:hover .sketchbook-blue-band{
    width: 100%;
    background: ${COLORS.blue};
  }

  .sketchbook-tile:hover .sketchbook-arrow{
    color: ${COLORS.white};
    transform: translate(2px, -2px);
  }

  .sketchbook-tile .tile-overlay{
    display: none;
  }

  .project-cover-image{
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    background: #f7f7f7;
    transition: transform .55s ease;
  }

  .project-tile:hover .project-cover-image{
    transform: scale(1.015);
  }

  .project-tile.empty{ cursor: default; }

  .square-placeholder-tile{
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
  }

  .square-placeholder-tile .placeholder{
    height: 100%;
    min-height: 0;
    aspect-ratio: 1 / 1 !important;
  }
  .project-tile .placeholder{ height: 100%; aspect-ratio: auto !important; transition: transform .55s ease; }
  .project-tile:not(.empty):hover .placeholder{ transform: scale(1.025); }

  .tile-overlay{
    font-family: "Univers Bold";
    position: absolute;
    inset: 0;
    display: flex;
    align-items: flex-end;
    padding: 20px;
    background: linear-gradient(transparent 45%, rgba(0,0,0,.72));
    color: white;
    opacity: 0;
    transition: opacity .3s ease;
  }

  .project-tile:hover .tile-overlay{
    font-family: "Univers Bold"; opacity: 1; }

  .placeholder{
    width: 100%;
    min-height: 220px;
    display: grid;
    place-items: center;
    padding: 24px;
    background:
      linear-gradient(135deg, rgba(239,131,104,.22), rgba(91,151,81,.16) 48%, rgba(136,155,206,.25));
    border: 1px solid rgba(0,0,0,.12);
    color: rgba(0,0,0,.55);
    text-align: center;
    font-size: 12px;
    letter-spacing: .03em;
    text-transform: none;
  }

  .placeholder-dark{
    background: #181818;
    border-color: rgba(255,255,255,.18);
    color: rgba(255,255,255,.65);
  }

  .detail{ max-width: 1240px; margin: 0 auto; }
  .detail-intro{ max-width: 720px; margin: 54px 0 58px; }

  

  .project-detail-title{
    color: ${COLORS.black};
  }

  .project-eyebrow{
    color: var(--accent-color, ${COLORS.coral});
  }

  .detail-images{
    display: grid;
    gap: 14px;
  }

  .detail-image-cell{
    min-width: 0;
    min-height: 0;
    background: transparent;
    opacity: 0;
    transform: translateY(14px);
    transition: opacity .7s ease, transform .7s ease;
  }

  .detail-image-cell.is-visible{
    opacity: 1;
    transform: translateY(0);
  }

    .detail-image-cell img{
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }

  .notting-hill-layout{
    --nh-gap: 14px;
    display: grid;
    grid-template-columns: minmax(0, 1.642fr) minmax(0, 1fr);
    gap: var(--nh-gap);
    width: 100%;
    align-items: stretch;
  }

  .nh-column{
    display: flex;
    flex-direction: column;
    gap: var(--nh-gap);
    min-width: 0;
  }

  .notting-hill-layout .detail-image-cell{
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    background: transparent;
  }

  .notting-hill-layout .detail-image-cell img{
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  .nh-column-right{
    display: grid;
    grid-template-rows: auto auto auto;
    gap: var(--nh-gap);
    align-self: start;
    height: auto;
  }

  .nh-image-005{
    position: static;
    min-height: 0;
    overflow: visible;
  }

  .nh-image-005 img{
    position: static;
    width: 100%;
    height: auto;
    max-height: none;
    object-fit: contain;
    object-position: center;
    transform: none;
  }

  .nh-image-006, .nh-image-007{
    min-height: 0;
  }

  .nh-image-006 img, .nh-image-007 img{
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  .stratford-cross-layout{
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    align-items: start;
  }

  .stratford-cross-layout .detail-image-cell{
    overflow: hidden;
    background: transparent;
  }

  .stratford-cross-layout img{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .sc-image-001, .sc-image-002{
    aspect-ratio: 0.78 / 1.38;
  }

  .sc-image-003{
    grid-column: 1 / -1;
    aspect-ratio: 2.1 / 1;
  }

  .claverton-down-layout{
    display: grid;
    gap: 14px;
  }

  .claverton-top-layout{
    display: grid;
    grid-template-columns: minmax(0, 1.55fr) minmax(0, 1fr);
    gap: 14px;
    align-items: stretch;
  }

  .claverton-left-stack{
    display: grid;
    gap: 14px;
    min-width: 0;
  }

  .cd-image-001 img, .cd-image-006 img, .cd-image-007 img{
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }

  .claverton-detail-strip{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
  }

  .claverton-detail-strip .detail-image-cell{
    min-width: 0;
    overflow: hidden;
    aspect-ratio: 0.52 / 1;
  }

  .claverton-detail-strip img{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .cd-image-008{
    min-height: 0;
    overflow: hidden;
  }

  .cd-image-008 img{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
  }

  .cd-image-007{
    overflow: hidden;
    margin-top: -20px;
  }

  .cd-image-007 img{
    transform: translateY(-20px);
    margin-bottom: -20px;
  }

.holy-island-layout, .holy-island-row{ display: grid; gap: 14px; align-items: start; }
.holy-island-row{ grid-template-columns: repeat(2, minmax(0, 1fr)); }
.holy-island-layout .detail-image-cell{ overflow: hidden; background: transparent; }
.holy-island-layout img{ width: 100%; height: auto; display: block; object-fit: contain; }
.hi-image-005{ display: flex; align-items: stretch; }
.hi-image-005 img{ height: 100%; object-position: center; }

  

  

  

  

  

  .domestic-community-layout{
    display: grid;
    gap: 14px;
  }

  .domestic-community-top-layout{
    display: grid;
    grid-template-columns: minmax(0, 1.04fr) minmax(0, 0.96fr);
    gap: 14px;
    align-items: stretch;
  }

  .domestic-community-right-stack{
    display: grid;
    grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
    gap: 14px;
    min-width: 0;
    min-height: 0;
  }

  .domestic-community-top-layout .detail-image-cell, .dc-image-002, .dc-image-003{
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    background: transparent;
  }

  .dc-image-001, .dc-image-004, .dc-image-005, .dc-image-002, .dc-image-003{
    overflow: hidden;
    background: transparent;
  }

  .dc-image-001{
    aspect-ratio: 0.78 / 1;
  }

  .dc-image-004{
    aspect-ratio: 1.5 / 1;
    display: grid;
    place-items: center;
  }

  .dc-image-005{
    aspect-ratio: 1.5 / 1;
  }

  .dc-image-002, .dc-image-003{
    aspect-ratio: 4.4 / 1;
  }

  .dc-image-001 img, .dc-image-004 img, .dc-image-005 img, .dc-image-002 img, .dc-image-003 img{
    width: 100%;
    height: 100%;
    display: block;
  }

  .dc-image-001 img{
    object-fit: cover;
    object-position: 36% 50%;
  }

  .dc-image-004 img{
    object-fit: contain;
    object-position: center bottom;
    transform: translateY(-24px) scale(1.02);
    transform-origin: center bottom;
  }

  .dc-image-005 img{
    object-fit: cover;
    object-position: center center;
  }

  .dc-image-002 img{
    object-fit: cover;
    object-position: center bottom;
  }

  .dc-image-003 img{
    object-fit: cover;
    object-position: center bottom;
  }

  .sydney-gardens-layout{
    display: grid;
    gap: var(--content-gap);
  }

  .sydney-gardens-layout .detail-image-cell{
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    background: ${COLORS.white};
  }

  .sydney-gardens-layout img{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
    object-position: center;
  }

  .sg-image-001{
    aspect-ratio: 2.18 / 1;
  }

  .sg-image-001 img{
    object-fit: cover;
    object-position: center 52%;
  }

  .sydney-middle-row, .sydney-bottom-row{
    display: grid;
    grid-template-columns: minmax(0, 1.56fr) minmax(0, 1fr);
    gap: var(--content-gap);
    align-items: start;
    min-width: 0;
  }

  .sg-image-002{
    aspect-ratio: 1.53 / 1;
  }

  .sg-image-002 img{
    transform: none;
    object-fit: contain;
    object-position: center;
  }

  .sydney-right-stack{
    display: grid;
    grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
    gap: var(--content-gap);
    min-width: 0;
    min-height: 0;
    align-items: start;
  }

  .sg-image-003{
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-self: end;
  }

  .sg-image-003 img{
    position: relative;
    top: -42%;
    width: 100%;
    height: auto;
    max-width: none;
    object-fit: contain;
    object-position: center bottom;
    transform: rotate(-90deg) scale(1.04);
    transform-origin: center center;
  }

  .sg-image-004{
    aspect-ratio: 1.34 / 1;
  }

  .sg-image-004 img{
    object-fit: contain;
    object-position: center;
    transform: none;
  }

  .sg-image-005{
    aspect-ratio: 1.34 / 1;
  }

  .sg-image-005 img{
    object-fit: contain;
    object-position: center;
    transform: none;
  }

  .sg-image-006{
    aspect-ratio: 0.76 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .sg-image-006 img{
    width: auto;
    height: 100%;
    max-width: none;
    object-fit: contain;
    object-position: center;
    transform: rotate(-90deg) scale(0.68);
    transform-origin: center center;
  }

  .paddington-heights-layout{
    display: grid;
    grid-template-columns: minmax(0, 2.9fr) minmax(0, 1fr);
    gap: var(--content-gap);
    align-items: stretch;
  }

  .paddington-left-block{
    display: grid;
    grid-template-rows: auto auto;
    gap: var(--content-gap);
    min-width: 0;
  }

  .paddington-top-row{
    display: grid;
    grid-template-columns: minmax(0, .48fr) minmax(0, 1fr);
    gap: var(--content-gap);
    width: 100%;
    aspect-ratio: 2.16 / 1;
  }

  .paddington-heights-layout .detail-image-cell{
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    background: ${COLORS.white};
  }

  .paddington-top-row .detail-image-cell{
    height: 100%;
  }

  .paddington-top-row img{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
  }

  .ph-image-001 img{
    transform: scale(1.03);
  }

  .ph-image-003 img{
    transform: scale(1.02);
  }

  .ph-image-002 img{
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
    object-position: center top;
  }

  .paddington-right-stack{
    display: grid;
    grid-template-rows: repeat(5, minmax(0, 1fr));
    gap: var(--content-gap);
    min-width: 0;
    height: 100%;
    align-self: stretch;
  }

  .paddington-right-stack .detail-image-cell{
    display: flex;
    align-items: flex-end;
    justify-content: center;
    min-height: 0;
  }

  .paddington-right-stack img{
    width: 98%;
    height: 98%;
    display: block;
    object-fit: contain;
    object-position: center;
    transform: none;
    transform-origin: center center;
  }

  .paddington-right-stack .detail-image-cell:first-child{
    align-items: flex-start;
  }

  .paddington-right-stack .detail-image-cell:last-child{
    align-items: flex-end;
  }

  .paddington-right-stack .detail-image-cell:not(:first-child):not(:last-child){
    align-items: center;
  }

  .ph-image-008{
    height: auto;
    margin-bottom: 0;
  }

  .ph-image-008 img{
    transform: none;
    object-position: center bottom;
  }

  .sketch-detail{
    min-height: calc(100vh - 76px);
    padding: 28px 34px 22px;
    display: flex;
    flex-direction: column;
  }

  .venice-sketch-detail{
    background: ${COLORS.white};
    color: ${COLORS.black};
  }

  .venice-sketch-frame{
    width: min(1120px, 1601.6px);
    height: min(68vh, 700px);
    margin: 20px auto 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .venice-sketch-frame img{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    display: block;
    object-fit: contain;
  }

  .venice-sketch-caption{
    width: min(1120px, 1601.6px);
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .venice-sketch-caption p{
    margin: 0;
    font-size: 13px;
    line-height: 1.4;
  }

  .venice-blue-swatch{
    width: 28px;
    height: 4px;
    flex: 0 0 auto;
    background: var(--accent-color, ${COLORS.blue});
  }

  .sketchbook-page{
    min-height: calc(100vh - 76px);
    background: ${COLORS.white};
    color: ${COLORS.black};
  }

  .sketchbook-page .eyebrow{ color: ${COLORS.blue}; }
  .sketchbook-page .section-heading{ color: ${COLORS.black}; }

  .sketchbook-page .sketch-grid{
    column-count: 3;
    column-gap: 110px;
    padding: 0 145.6px;
  }

  .sketchbook-page .sketch-item{
    width: 42%;
    margin: 0 auto 110px;
    padding: 0;
    border: 0;
    break-inside: avoid;
    overflow: hidden;
    background: ${COLORS.white};
    cursor: zoom-in;
  }

  .sketch-item img{
    width: 100%;
    height: auto;
    display: block;
  }

  .sketchbook-single-page{
    width: 100%;
    height: calc(100dvh - 76px);
    min-height: calc(100dvh - 76px);
    padding: 0 34px;
    overflow: hidden;
    background: ${COLORS.white};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sketchbook-single-frame{
    width: 100%;
    height: 100%;
    padding: 28px 110px 28px 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .sketchbook-single-frame img{
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .about{
    display: grid;
    grid-template-columns: minmax(340px, 0.82fr) minmax(0, 1fr);
    min-height: calc(100vh - 76px);
    align-items: center;
  }

  .about-image{
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 76px);
    padding: 24px 0 24px 72.8px;
  }

  .about-video-frame{
    position: relative;
    height: min(calc(100vh - 124px), 820px);
    aspect-ratio: 9 / 16;
    width: auto;
    overflow: hidden;
    background: ${COLORS.white};
  }

  .about-video-frame video{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
  }

  .about-video-logo{
    position: absolute;
    z-index: 3;
    right: 5%;
    bottom: 4%;
    width: 18%;
    max-width: 86px;
    height: auto;
    display: block;
    pointer-events: none;
  }

  .about-video-white-fade{
    position: absolute;
    z-index: 4;
    inset: 0;
    background: ${COLORS.white};
    opacity: 0;
    pointer-events: none;
    will-change: opacity;
  }

  .about-video-play{
    position: absolute;
    z-index: 5;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 104px;
    height: 76px;
    padding: 0;
    border: 0;
    border-radius: 16px;
    background: ${COLORS.black};
    color: ${COLORS.white};
    display: grid;
    place-items: center;
    cursor: pointer;
  }

  .about-video-play span{
    display: block;
    font-size: 38px;
    line-height: 1;
    margin-left: 5px;
  }

  .about-copy{
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 145.6px 127.4px 145.6px 54.6px;
  }

  .about-page-title{
    position: absolute;
    top: 64px;
    left: 54.6px;
    font-family: "Univers Roman";
    font-size: clamp(42px, 91px, 70px);
    line-height: 1;
    font-weight: 400;
    letter-spacing: -.035em;
    margin: 10px 0 18px;
  }

  .contact-intro{
    max-width: 620px;
    font-size: 16px;
    line-height: 1.65;
  }

  .about-columns{
    display: grid;
    grid-template-columns: 1fr;
    gap: 36px;
    margin-top: 54px;
    padding-top: 30px;
    border-top: 1px solid rgba(0,0,0,.18);
  }

  .about-columns h2{
    font-family: "Univers Bold";
    font-size: 13px;
    text-transform: none;
    letter-spacing: .04em;
  }

  .contact-heading-blue{
    color: ${COLORS.blue};
  }

  .about-columns p{ line-height: 1.6; }

  /* One spacing rule for every workbook and project-image layout. */

  .detail-images, .notting-hill-layout, .nh-column, .nh-column-right, .stratford-cross-layout, .claverton-down-layout, .claverton-top-layout, .claverton-left-stack, .claverton-detail-strip, .holy-island-layout, .holy-island-row, .domestic-community-layout, .domestic-community-top-layout, .domestic-community-right-stack, .paddington-heights-layout, .paddington-left-block, .paddington-right-stack, .paddington-top-row{
    gap: var(--content-gap) !important;
  }

  /* Latest numbered refinements: 1.4, 1.5, 1.6, 1.9, 1.10, 1.12, 1.13 */

  /* 1.12 - all project detail pages use the same intro rhythm. */
  .detail{
    max-width: 1240px;
    margin: 0 auto;
  }

  .detail-intro{
    max-width: 720px;
    margin: 42px 0 48px;
  }

  .detail-intro p:last-child{
    max-width: 620px;
    margin-bottom: 0;
  }

  .project-page-logo{
    margin-top: 56px;
    padding: 24px 0 0;
  }

  /* 1.4 - enlarge Paddington 004-008 again while keeping the five-image unit
     locked to the top and bottom of the right-hand grid. */
  .paddington-right-stack{
    height: 100%;
    align-self: stretch;
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .paddington-right-stack .detail-image-cell{
    position: relative;
    overflow: hidden;
  }

  .paddington-right-stack img{
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    transform: scale(1.5);
    transform-origin: center center;
  }

  .paddington-right-stack .detail-image-cell:first-child img{
    transform-origin: center top;
  }

  .paddington-right-stack .detail-image-cell:last-child img{
    transform-origin: center bottom;
    object-position: center bottom;
  }

  /* 1.5 - move the Domestic 004 artwork itself substantially upward inside
     the existing, unchanged bounding box. */
  .dc-image-004{
    position: relative;
    overflow: hidden;
  }

  .dc-image-004 img{
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center bottom;
    transform: translateY(-34%) scale(1.02);
    transform-origin: center bottom;
  }

  /* 1.6 - keep Sydney 003 at its corrected raised position, allow it to be
     visible above its own cell, and crop the lower edge of 002 so there is a
     clean 14px visual separation. */
  .sg-image-002{
    position: relative;
    overflow: hidden;
  }

  .sg-image-002 img{
    clip-path: inset(0 0 82px 0);
  }

  .sg-image-003{
    position: relative;
    z-index: 3;
    overflow: visible !important;
  }

  .sg-image-003 img{
    top: -42%;
    z-index: 3;
  }

  /* 1.9 - Sketchbook is explicitly a three-column grid.  These page-specific
     gaps are intentionally independent of the normal 14px/8px site rule. */
  .sketchbook-page .sketch-grid{
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-count: initial;
    gap: 120px 110px;
    padding: 0 127.4px;
    align-items: start;
  }

  .sketchbook-page .sketch-item{
    width: 50%;
    margin: 0;
    justify-self: center;
    break-inside: auto;
  }

            /* Latest refinements: 1.4, 1.5, 1.6, 1.9, 1.10 only. */
  .ph-image-004 img{
    transform: translateY(-12%) scale(1.5) !important;
    transform-origin: center top !important;
  }

  .ph-image-008 img{
    transform: translateY(12%) scale(1.5) !important;
    transform-origin: center bottom !important;
  }

  .dc-image-004 img{
    transform: translateY(-17%) scale(1.02) !important;
  }

  .sg-image-003 img{
    top: -21% !important;
  }

  .sketchbook-page .sketch-item:nth-child(12){
    width: 45% !important;
    justify-self: end !important;
    overflow: hidden;
  }

  .sketchbook-page .sketch-item:nth-child(12) img{
    width: 111.111% !important;
    max-width: none;
    transform: none !important;
    transform-origin: left center;
  }

      /* Latest refinements: 1.4, 1.6, 1.9, 1.10 */

  /* 1.4 - move only Paddington 004 upward by a further ~15% of its own height. */
  .ph-image-004 img{
    transform: translateY(-27%) scale(1.5) !important;
    transform-origin: center top !important;
  }

  /* 1.6 - crop roughly 30% from the VISUAL top edge of rotated Sydney 003.
     Because the image is rotated 90deg anticlockwise, its source right edge
     becomes its visual top edge. Position/scale remain unchanged. */
  .sg-image-003 img{
    clip-path: inset(0 30% 0 0) !important;
  }

  /* 1.9 - keep the final Sketchbook image hard-aligned with the grid's right edge. */
  .sketchbook-page .sketch-item:nth-child(12){
    grid-column: 3 !important;
    justify-self: end !important;
    margin-right: 0 !important;
    transform: translateX(0) !important;
  }

  /* 1.10 - crop the visual top of Marika 001 and 003 by the same ~40% amount.
     001 is rotated 90deg clockwise, so cropping its source left edge crops its
     visual top edge. 003 is unrotated, so crop its source top edge directly. */

  

      /* Refinements from reference: 1.6, 1.9, 1.10 */

  /* 1.6 - give Sydney 003 back half of the 30% visual-top crop. */
  .sg-image-003 img{
    clip-path: inset(0 15% 0 0) !important;
  }

  /* 1.9 - Sketchbook is a true three-column grid. The heading uses the same
     left edge as the grid and the final image sits flush to the grid's right edge. */
  .sketchbook-page .section-heading{
    width: auto !important;
    max-width: none !important;
    margin-left: 145.6px !important;
    margin-right: 145.6px !important;
    padding-left: 0 !important;
    text-align: left !important;
  }

  .sketchbook-page .sketch-grid{
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    column-count: initial !important;
    column-gap: 110px !important;
    row-gap: 110px !important;
    padding: 0 145.6px !important;
    align-items: start !important;
  }

  .sketchbook-page .sketch-item{
    width: 50% !important;
    margin: 0 !important;
    justify-self: center !important;
    align-self: start !important;
  }

  .sketchbook-page .sketch-item:nth-child(12){
    grid-column: 3 !important;
    width: 50% !important;
    margin: 0 !important;
    justify-self: end !important;
    align-self: start !important;
    overflow: hidden !important;
  }

  .sketchbook-page .sketch-item:nth-child(12) img{
    width: 111.111% !important;
    max-width: none !important;
    transform: translateX(-10%) !important;
    transform-origin: right center !important;
  }

  /* 1.10 - Marika rebuilt from the supplied reference image.
     Ignore all earlier per-image alignment/crop overrides for this project. */

  

  

  

  

      /* Latest refinements: 1.6 and 1.9 only */

  /* 1.6 - restore more of Sydney 002 bottom and Sydney 003 top. */
  .sg-image-002 img{
    clip-path: inset(0 0 34px 0) !important;
  }
  .sg-image-003 img{
    clip-path: inset(0 7.5% 0 0) !important;
  }

  /* 1.9 - exact 3-column row grid, retaining the current generous spacing. */
  .sketchbook-page .section-heading{
    margin-left: 145.6px !important;
    margin-right: 145.6px !important;
    padding-left: 0 !important;
    width: auto !important;
    max-width: none !important;
    text-align: left !important;
  }
  .sketchbook-page .sketch-grid{
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    grid-auto-flow: row !important;
    column-count: initial !important;
    column-gap: 110px !important;
    row-gap: 110px !important;
    padding: 0 145.6px !important;
    align-items: start !important;
  }
  .sketchbook-page .sketch-item, .sketchbook-page .sketch-item:nth-child(12){
    grid-column: auto !important;
    width: 50% !important;
    margin: 0 !important;
    justify-self: center !important;
    align-self: start !important;
    transform: none !important;
    overflow: hidden !important;
  }
  .sketchbook-page .sketch-item img, .sketchbook-page .sketch-item:nth-child(12) img{
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    transform: none !important;
    object-fit: contain !important;
    object-position: center !important;
  }

      /* Final 1.10 execution - Marika Alderton spacing and image 001 scale */

  

  

  

  

  

  

      /* Latest fix - Marika 1.10 + one-line titles on every project page */

  .detail .project-detail-title{
    white-space: nowrap !important;
    max-width: none !important;
    width: max-content !important;
    font-size: min(70px, 81.9px) !important;
  }

  

  

      /* Marika Alderton - exact reference-mask rebuild.
     This isolated v2 layout is the only active geometry for Marika. */

  

  /* Reference mask: tall 001 at left; 003/004/005 stacked at right. */

  

  /* 001: use the entire SVG. Rotate it and scale only enough to reproduce
     the tall left-hand drawing in the supplied mask. */

  

  /* The two line drawings use shallow reference boxes. Keeping the source
     at full width crops only its internal white canvas, not the drawing width. */

  

  /* 002 is already a composite of the three model photographs in exactly
     the lower arrangement shown by the supplied reference. Display it whole. */

  

  /* All project titles remain on one line. */
  .detail .project-detail-title{
    white-space: nowrap !important;
    max-width: none !important;
    width: max-content !important;
    font-size: min(70px, 81.9px) !important;
  }

      /* ================================================================
     MARIKA ALDERTON - CLEAN REFERENCE-MASK REBUILD
     This block uses new class names only. Historical Marika selectors
     elsewhere in this file do not match these classes and cannot affect it.
     Geometry is taken directly from the supplied reference mask.
     ================================================================ */

  .marika-mask-detail .detail-intro{
    max-width: 720px !important;
    margin: 54px 0 48px !important;
  }

  .marika-mask-detail .detail-intro p:last-child{
    max-width: 620px !important;
    margin-bottom: 0 !important;
  }

  .marika-mask-layout{
    display: block !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Reference top group: right edge aligns with the full-width model image.
     Measured mask proportions: top group 90.3% of full width; left 32.2%,
     central white gap 13.8%, right 54.0%; height/width = 430/580. */
  .marika-mask-top{
    position: relative !important;
    display: grid !important;
    grid-template-columns: 32.2% 54% !important;
    column-gap: 13.8% !important;
    width: 90.3% !important;
    aspect-ratio: 580 / 430 !important;
    margin: 0 0 0 auto !important;
    align-items: stretch !important;
  }

  .marika-mask-top .detail-image-cell, .marika-mask-002{
    opacity: 0;
    transform: translateY(14px);
    transition: opacity .7s ease, transform .7s ease;
  }

  .marika-mask-top .detail-image-cell.is-visible, .marika-mask-002.is-visible{
    opacity: 1;
    transform: translateY(0);
  }

  .marika-mask-001{
    position: relative !important;
    width: 140% !important;
    margin-left: -40% !important;
    height: calc(100% + 18px) !important;
    align-self: start !important;
    overflow: hidden !important;
    background: ${COLORS.white} !important;
  }

  /* 001's SVG is landscape, but its visible plan becomes the tall left-hand
     drawing when rotated. 252% is calculated from the SVG's visible-content
     bounds, so the linework itself fills the measured mask without side loss. */
  .marika-mask-001 img{
    position: absolute !important;
    top: 49% !important;
    left: 60.7143% !important;
    width: 180% !important;
    height: auto !important;
    max-width: none !important;
    display: block !important;
    object-fit: initial !important;
    object-position: initial !important;
    transform: translate(-58%, -50%) rotate(90deg) !important;
    transform-origin: center center !important;
    clip-path: none !important;
  }

  /* Right-hand stack measured from the reference:
     003 = 26.3%, gap = 7.0%, 004 = 24.9%, gap = 4.2%, 005 = 35.8%.
     The stack ends level with the tall 001 drawing. */
  .marika-mask-right{
    display: grid !important;
    grid-template-rows: 26.3% 7% 24.9% 4.2% 35.8% !important;
    width: 100% !important;
    height: 98.2% !important;
    align-self: start !important;
    min-width: 0 !important;
    min-height: 0 !important;
  }

  .marika-mask-003{ grid-row: 1 !important; }
  .marika-mask-004{ grid-row: 3 !important; }
  .marika-mask-005{ grid-row: 5 !important; }

  .marika-mask-003, .marika-mask-004, .marika-mask-005{
    position: relative !important;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden !important;
    background: ${COLORS.white} !important;
  }

  /* 003 and 004 contain large white margins in their SVG canvases.
     Scaling by width and clipping only that blank canvas reproduces the mask
     while preserving every line of the drawings. */
  .marika-mask-003 img, .marika-mask-004 img{
    position: absolute !important;
    bottom: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: auto !important;
    max-width: none !important;
    display: block !important;
    transform: translateY(4%) !important;
    transform-origin: center bottom !important;
  }

  .marika-mask-005 img{
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    display: block !important;
    object-fit: cover !important;
    object-position: center center !important;
    transform: none !important;
    clip-path: none !important;
  }

  /* 002 is deliberately one composite photograph containing the two upper
     model views and the wide lower model view. Its visible-content ratio
     matches the supplied reference, so it is left uncropped. */
  .marika-mask-002{
    width: 100% !important;
    margin: 7.5% 0 0 !important;
    overflow: visible !important;
    background: ${COLORS.white} !important;
  }

  .marika-mask-002 img{
    width: 100% !important;
    height: auto !important;
    max-width: 100% !important;
    display: block !important;
    object-fit: contain !important;
    object-position: center top !important;
    transform: none !important;
    clip-path: none !important;
  }

  /* All project titles remain on one line, as requested. */
  .detail .project-detail-title{
    white-space: nowrap !important;
    max-width: none !important;
    width: max-content !important;
    font-size: min(70px, 81.9px) !important;
  }

      /* Sketchbook intro alignment: match standard project-page content position
     without changing the existing sketch grid. */
  .sketchbook-page > .detail-intro{
    margin-left: max(0px, calc((1820px - 1240px) / 2)) !important;
  }

  .sketchbook-page > .detail-intro{
    max-width: 720px !important;
    margin-top: 54px !important;
    margin-right: 0 !important;
    margin-bottom: 58px !important;
  }

      /* ================================================================
     FINAL TYPOGRAPHY / SWEEP / VIDEO CONTROL NORMALISATION
     Keep headings and eyebrow labels as designed; standardise body copy.
     ================================================================ */

  .home-description-copy p, .detail-intro p:not(.eyebrow), .sketchbook-page .detail-intro p:not(.eyebrow), .about-copy p, .section-heading p:not(.eyebrow){
    font-family: "Univers Light" !important;
    font-weight: 300 !important;
    font-size: 16px !important;
    line-height: 1.65 !important;
    letter-spacing: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 16px !important;
  }

  .home-description-copy p:last-child, .detail-intro p:not(.eyebrow):last-child, .sketchbook-page .detail-intro p:not(.eyebrow):last-child, .about-copy p:last-child, .section-heading p:not(.eyebrow):last-child{
    margin-bottom: 0 !important;
  }

  /* Pure white left-to-right sweep: no coloured edge/bar. */
  .section-sweep{
    background: ${COLORS.white} !important;
    border: 0 !important;
    border-right: 0 !important;
    box-shadow: none !important;
  }

  .section-sweep::before, .section-sweep::after{
    content: none !important;
    display: none !important;
  }

  /* Replay control: large black rounded rectangle, no circular ring. */
  .about-video-play{
    appearance: none !important;
    -webkit-appearance: none !important;
    width: 118px !important;
    height: 82px !important;
    padding: 0 !important;
    border: 0 !important;
    outline: 0 !important;
    border-radius: 18px !important;
    background: ${COLORS.black} !important;
    color: ${COLORS.white} !important;
    box-shadow: none !important;
    display: grid !important;
    place-items: center !important;
  }

  .about-video-play span{
    display: block !important;
    font-size: 42px !important;
    line-height: 1 !important;
    margin-left: 6px !important;
    color: ${COLORS.white} !important;
  }

  /* Home opening-to-content breathing space: keep the scroll cue visually
     separate from the photo/text section. */
  .home-description{
    margin-top: 28vh !important;
  }

      /* About replay control: standalone black rounded triangle only. */
  .about-video-play{
    appearance: none !important;
    -webkit-appearance: none !important;
    width: 96px !important;
    height: 96px !important;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    outline: 0 !important;
    display: grid !important;
    place-items: center !important;
  }

  .about-video-play span{
    width: 68px !important;
    height: 76px !important;
    margin: 0 !important;
    background: ${COLORS.black} !important;
    display: block !important;
    clip-path: polygon(16% 4%, 24% 1%, 34% 2%, 91% 42%, 96% 50%, 94% 59%, 86% 66%, 34% 98%, 24% 99%, 16% 96%, 11% 90%, 9% 82%, 9% 18%, 11% 10%) !important;
    border-radius: 16px !important;
    transform: translateX(4px) !important;
    color: transparent !important;
    font-size: 0 !important;
  }

  /* Refined About replay icon: clean standalone rounded black triangle. */
  .about-video-play{
    width: 96px !important;
    height: 96px !important;
    border: 0 !important;
    background: transparent !important;
    border-radius: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
  }

  .about-video-play-icon{
    width: 66px !important;
    height: 74px !important;
    display: block !important;
    overflow: visible !important;
    transform: translateX(3px) !important;
  }

  .about-video-play-icon path{
    fill: ${COLORS.black} !important;
  }

  /* Supplied Play Button.svg used directly as the replay control. */
  .about-video-play{
    width: 104px !important;
    height: 104px !important;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    display: grid !important;
    place-items: center !important;
  }

  .about-video-play-icon{
    width: 82px !important;
    height: auto !important;
    display: block !important;
    object-fit: contain !important;
    transform: none !important;
  }

    /* Sketch study pages: remove the black bar beneath the Back button. */

  .sketch-detail::before, .venice-sketch-detail::before{
    content: none !important;
    display: none !important;
  }

  /* ================================================================
     FINAL SITE-WIDE TYPOGRAPHY
     Body text = Univers 45 Light
     Headings = Univers 55 Roman
     Subheadings / eyebrow labels = Univers 65 Bold
     ================================================================ */

  body, p, li, a, button, input, textarea, select, .home-description-copy, .detail-intro p:not(.eyebrow), .about-copy p, .sketchbook-page .detail-intro p:not(.eyebrow), .venice-sketch-caption p, .tile-overlay, .sketchbook-title{
    font-family: "Univers Light" !important;
    font-weight: 300 !important;
  }

  h1, .home-description h1, .project-detail-title, .about-page-title, .section-heading h1{
    font-family: "Univers Roman" !important;
    font-weight: 400 !important;
  }

  .final-name{
    font-family: "Univers Light" !important;
    font-weight: 300 !important;
    font-style: normal !important;
    font-synthesis: none;
  }

  h2, h3, .eyebrow, .project-eyebrow, .eyebrow-home, .eyebrow-workbook, .contact-heading-blue, .section-heading .eyebrow, .subheading{
    font-family: "Univers Bold" !important;
    font-weight: 700 !important;
  }

  /* ================================================================
     FINAL TEXT-ONLY FORMATTING REVIEW
     No image, grid, video, logo or page geometry changes in this block.
     ================================================================ */

  /* Keep all text fully visible with the Univers fonts. */
  p, h1, h2, h3, .brand-text, .nav nav button, .tile-overlay, .sketchbook-title, .venice-sketch-caption p{
    overflow: visible !important;
    text-overflow: clip !important;
  }

  /* Consistent body copy across Home, project pages, Sketchbook and About. */
  .home-description-copy p, .detail-intro p:not(.eyebrow), .sketchbook-page .detail-intro p:not(.eyebrow), .about-copy p, .venice-sketch-caption p{
    font-family: "Univers Light" !important;
    font-weight: 300 !important;
    font-size: 16px !important;
    line-height: 1.58 !important;
    letter-spacing: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 18px !important;
    white-space: normal !important;
    overflow-wrap: normal !important;
    word-break: normal !important;
    hyphens: none !important;
  }

  .home-description-copy p:last-child, .detail-intro p:not(.eyebrow):last-child, .sketchbook-page .detail-intro p:not(.eyebrow):last-child, .about-copy p:last-child, .venice-sketch-caption p:last-child{
    margin-bottom: 0 !important;
  }

  /* Main headings: retain the original visual hierarchy but give Univers
     enough line-height so ascenders/descenders are never clipped. */
  .home-description h1, .section-heading h1, .detail-intro h1, .about-copy h1, .project-detail-title, .about-page-title{
    font-family: "Univers Roman" !important;
    font-weight: 400 !important;
    line-height: 1.06 !important;
    letter-spacing: -0.025em !important;
    padding-top: 0.04em !important;
    padding-bottom: 0.08em !important;
  }

  .home-description h1{
    font-size: clamp(38px, 87.36px, 74px) !important;
    max-width: 100% !important;
    margin-top: 0 !important;
    margin-bottom: 24px !important;
  }

  .section-heading h1, .about-page-title{
    font-size: clamp(40px, 85.54px, 68px) !important;
    margin-top: 0 !important;
    margin-bottom: 20px !important;
  }

  /* Project titles remain on one line, but now scale to the available width
     rather than being allowed to run outside the viewport. */
  .detail .project-detail-title, .sketchbook-page .project-detail-title{
    white-space: nowrap !important;
    width: auto !important;
    max-width: 100% !important;
    font-size: min(68px, 76.44px) !important;
    margin-top: 0 !important;
    margin-bottom: 22px !important;
  }

  /* Subheadings / labels. */
  .eyebrow, .project-eyebrow, .eyebrow-home, .eyebrow-workbook, .contact-heading-blue, h2, h3{
    font-family: "Univers Bold" !important;
    font-weight: 700 !important;
    line-height: 1.25 !important;
  }

  .eyebrow, .project-eyebrow, .eyebrow-home, .eyebrow-workbook{
    font-size: 11px !important;
    letter-spacing: 0.035em !important;
    margin-top: 0 !important;
    margin-bottom: 12px !important;
  }

  .contact-heading-blue{
    margin-top: 0 !important;
    margin-bottom: 12px !important;
  }

  /* Keep the Home copy tidy beside the image without changing the image. */
  .home-description-copy{
    max-width: 610px !important;
  }

  /* Keep project/About paragraphs at a readable measure and preserve
     paragraph breaks without altering their surrounding page geometry. */
  .detail-intro p:not(.eyebrow), .sketchbook-page .detail-intro p:not(.eyebrow), .about-copy p{
    max-width: 620px !important;
  }

  /* Navigation and utility text remain restrained and consistent. */
  .brand-text, .nav nav button{
    font-family: "Univers Light" !important;
    font-weight: 300 !important;
    line-height: 1.2 !important;
  }

  .brand-text, .nav nav button{
    font-size: 14px !important;
    letter-spacing: 0.025em !important;
  }

  /* Workbook tile labels: prevent titles being cut off. */
  .tile-overlay span, .sketchbook-title{
    white-space: normal !important;
    overflow-wrap: normal !important;
    word-break: normal !important;
    line-height: 1.12 !important;
  }

      /* Final requested navigation/text-position refinements. */

  /* Portfolio wordmark: white on About/Contact and Sketchbook only. */
  .nav.nav-brand-white .brand, .nav.nav-brand-white .brand-text{
    color: ${COLORS.white} !important;
  }

  /* Sketch Study back control occupies the same relative page position as
     project-detail Back controls. This changes the text/control position only. */
  .sketch-detail, .venice-sketch-detail{
    padding-top: 64px !important;
  }

  /* Give the two-line Home title reveal a little more vertical room so the
     Univers Roman glyphs are not clipped along their lower edge. */
  .final-text-mask{
    top: 29% !important;
    bottom: 27% !important;
  }

  .final-name{
    line-height: 0.82 !important;
  }

    /* ================================================================
     EXACT SCREENSHOT FIXES
     ================================================================ */

  /* On every coloured/non-Home navigation bar, Portfolio is white. */
  .nav.nav-brand-white .brand, .nav.nav-brand-white .brand-text{
    color: ${COLORS.white} !important;
  }

  /* Sketch Study Back control: same left edge as project-detail Back control. */

  /* Home title reveal: extend only the bottom of the clipping mask.
     Keep the text block's original effective height so Wilf/Edwards do not
     move or scale; the extra mask area simply reveals the clipped lower edge. */
  .final-text-mask{
    top: 29% !important;
    bottom: 18% !important;
  }

  .final-name{
    height: 83.02% !important;
  }

    /* ================================================================
     FINAL FIVE REQUESTED FIXES
     ================================================================ */

  /* Sketch Study now uses the same page-wrap/detail geometry as project pages.
     Remove the sketch-specific padding so page-wrap provides the exact left edge. */
  .sketch-detail.venice-sketch-detail{
    max-width: 1240px !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding: 64px 34px 22px !important;
  }

  /* Extend the Home title's clipping area downward only.
     The title block retains the same effective height/position; only the mask
     has more room below it, so the bottom of Edwards cannot be clipped. */
  .final-text-mask{
    top: 29% !important;
    bottom: 6% !important;
  }

  .final-name{
    height: 67.69% !important;
    overflow: visible !important;
  }

  /* Sketchbook: 20% larger than the current 50% image width, same 3 columns. */
  .sketchbook-page .sketch-grid{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .sketchbook-page .sketch-item, .sketchbook-page .sketch-item:nth-child(12){
    width: 60% !important;
  }

      /* Sketch Study Back button: exactly match project-page Back button. */

  /* Home title sequence: lower the text within the existing reveal mask
     without changing its scale. */
  .final-name{
    transform: translateY(5%) translateX(-100%) !important;
  }

  .final-animation-stage.text-revealed .final-name{
    transform: translateY(5%) translateX(0) !important;
  }

  /* ================================================================
     CURRENT REQUESTS
     ================================================================ */

  /* Every project image uses the same scroll-in reveal. */
  .detail .detail-image-cell{
    opacity: 0 !important;
    transform: translateY(18px) !important;
    transition: opacity .72s ease, transform .72s ease !important;
  }

  .detail .detail-image-cell.is-visible{
    opacity: 1 !important;
    transform: translateY(0) !important;
  }

  /* Home text/photo section fits inside one browser screen. */
  .home-description{
    height: calc(100vh - 76px) !important;
    min-height: 0 !important;
    padding: 3.5vh 45.5px !important;
    overflow: hidden !important;
  }

  .home-description-grid{
    height: 100% !important;
    min-height: 0 !important;
    align-items: center !important;
    gap: 91px !important;
  }

  .home-description-grid > div:first-child{
    min-height: 0 !important;
    align-self: center !important;
  }

  .home-description h1{
    font-size: clamp(38px, 77.35px, 66px) !important;
    line-height: 1.02 !important;
    margin-bottom: 18px !important;
  }

  .home-description-copy p{
    font-size: 15px !important;
    line-height: 1.5 !important;
    margin-bottom: 12px !important;
  }

  .home-models-placeholder{
    height: 100% !important;
    max-height: 100% !important;
    align-self: center !important;
  }

  .home-studio-photo{
    height: 100% !important;
    max-height: 100% !important;
    object-fit: cover !important;
  }

  /* Initial/end video state shows the first film frame with the play icon. */
  .about-video-white-fade{
    opacity: 0;
  }

  .about-video-play:hover .about-video-play-icon{
    filter: invert(1) !important;
  }

    /* ================================================================
     LATEST REQUESTS
     ================================================================ */

  /* Sketch Study Back button = project page Back button exactly. */

  /* Sketchbook: 30% larger than the current image widths, same 3 columns. */
  .sketchbook-page .sketch-grid{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .sketchbook-page .sketch-item, .sketchbook-page .sketch-item:nth-child(12){
    width: 78% !important;
  }

  /* Replay icon: fade away after click, white on hover. */
  .about-video-play{
    opacity: 1 !important;
    transition: opacity .32s ease !important;
  }

  .about-video-play.is-fading{
    opacity: 0 !important;
    pointer-events: none !important;
  }

  .about-video-play-icon{
    transition: filter .22s ease !important;
  }

  .about-video-play:hover .about-video-play-icon{
    filter: invert(1) !important;
  }

      /* Correct final video behaviour: visible from frame one, no white overlay. */
  .about-video-white-fade{
    display: none !important;
  }

  .about-video-play{
    opacity: 1 !important;
    transition: opacity .32s ease !important;
    background: transparent !important;
  }

  .about-video-play.is-fading{
    opacity: 0 !important;
    pointer-events: none !important;
  }

  .about-video-play-icon{
    transition: filter .22s ease !important;
  }

  .about-video-play:hover .about-video-play-icon{
    filter: invert(1) !important;
  }

  /* End-of-film fade: white over 1.5 seconds. */
  .about-video-white-fade{
    display: block !important;
    position: absolute !important;
    z-index: 4 !important;
    inset: 0 !important;
    background: ${COLORS.white} !important;
    opacity: 0;
    pointer-events: none !important;
    transition: opacity 1.5s ease !important;
  }

  /* Workbook loading screen: keep the page hidden until its cover images are ready. */
  .workbook-loader{
    position: fixed;
    z-index: 30;
    inset: 76px 0 0;
    display: grid;
    place-items: center;
    background: ${COLORS.white};
    opacity: 1;
    pointer-events: all;
    transition: opacity .45s ease;
  }

  .workbook-loader.is-leaving{
    opacity: 0;
    pointer-events: none;
  }

  .workbook-loader img{
    width: clamp(70px, 145.6px, 118px);
    height: auto;
    display: block;
  }

  /* The final 1.5 seconds of the film are the fade itself, so white is reached
     exactly when playback ends. */
  .about-video-white-fade{
    display: block !important;
    position: absolute !important;
    z-index: 4 !important;
    inset: 0 !important;
    background: ${COLORS.white} !important;
    opacity: 0;
    pointer-events: none !important;
    transition: opacity 1.5s linear;
  }

  /* ================================================================
     RESPONSIVE SAFETY PASS
     Prevent text/image overlap on smaller laptops, tablets and phones
     while preserving the current desktop layout.
     ================================================================ */

  /* General safeguards */
  img, video, svg{
    max-width: 100%;
  }

  .page-wrap, .detail, .workbook, .about, .home-description, .home-description-grid, .project-grid, .detail-images{
    min-width: 0;
  }

  h1, h2, h3, p, .project-detail-title, .about-page-title{
    overflow-wrap: break-word;
  }

  /* Smaller laptops */
    /* Tablet and narrow laptop */
    /* Mobile */
    /* ================================================================
     MOBILE / SMALL-SCREEN TEXT SAFETY
     Text only: prevent collisions without changing image geometry.
     ================================================================ */

        /* ================================================================
     SMALL LAPTOP TEXT REFINEMENT
     Keep mobile rules intact; improve 901-1180px only.
     ================================================================ */
    /* ================================================================
     MOBILE TITLE SEQUENCE FIT
     Keep animation structure/movement; reduce scale so the expanded
     Wilf Edwards title aligns with the content/image width below.
     ================================================================ */
      /* Mobile: retain the same project image compositions as desktop/laptop. */

  /* ================================================================
     CLEAN RESPONSIVE SYSTEM
     Desktop is the master. Smaller screens scale from it rather than
     introducing alternative project compositions.
     ================================================================ */

  html, body, #root, .site{
    width: 100%;
    min-width: 0;
  }

  *, *::before, *::after{
    box-sizing: border-box;
  }

  img, video, svg{
    max-width: 100%;
  }

  .page-wrap, .detail, .workbook, .about, .home-description, .home-description-grid, .detail-images, .project-grid, .project-column, .detail-image-cell{
    min-width: 0;
  }

  /* Fluid typography across desktop and laptop widths. */
  .home-description h1{
    font-size: clamp(40px, 83.72px, 78px);
    line-height: 1.04;
  }

  .section-heading h1, .project-detail-title, .about-page-title{
    font-size: clamp(42px, 91px, 76px);
    line-height: 1.03;
  }

  .home-description-copy p, .detail-intro p:not(.eyebrow), .sketchbook-page .detail-intro p:not(.eyebrow), .about-copy p, .venice-sketch-caption p, .contact-intro{
    font-size: clamp(14px, 20.02px, 16px);
    line-height: 1.55;
    max-width: 100%;
  }

  .detail-intro, .home-description-copy, .about-copy, .section-heading{
    min-width: 0;
    max-width: 100%;
  }

  h1, h2, h3, p, .project-detail-title, .about-page-title, .section-heading h1{
    overflow-wrap: break-word;
  }

  /* Project compositions stay identical to desktop and simply scale
     with the available content width. */
  .detail-images, .nh-layout, .sc-layout, .cd-layout, .hi-layout, .marika-mask-layout, .dc-layout, .sg-layout, .ph-layout, .marika-mask-top, .marika-mask-right{
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .detail-image-cell{
    min-width: 0;
  }

  .detail-image-cell img{
    max-width: 100%;
  }

  /* ------------------------------------------------
     SMALL LAPTOP / TABLET LANDSCAPE: 1180px and below
     ------------------------------------------------ */
    /* ------------------------------------------------
     TABLET / SMALL SCREEN: 900px and below
     ------------------------------------------------ */
    /* ------------------------------------------------
     MOBILE: 640px and below
     ------------------------------------------------ */
        /* ================================================================
     FINAL PHONE / SMALL DEVICE TYPOGRAPHY
     ================================================================ */
    /* Mobile title sequence: much smaller and safely contained. */

  /* ================================================================
     MASTER-SCALE RESPONSIVE SYSTEM
     Laptop/desktop scaling is handled by desktop-master-canvas in JSX.
     Only phones have an independent responsive layout.
     ================================================================ */

  .desktop-master-canvas{
    transform-origin: top left;
  }

  .project-image-master-shell{
    transform-origin: top left;
    max-width: 100%;
  }

  /* ================================================================
     TRUE UNIFORM LAPTOP SCALE
     The desktop composition is frozen at the 1820px reference width.
     It is then scaled as one finished object; nothing reflows.
     ================================================================ */
  html, body, #root, .site{
    overflow-x: hidden !important;
  }

  .desktop-master-viewport{
    width: 100%;
    overflow-x: hidden;
    position: relative;
  }

  .desktop-master-canvas{
    width: 1820px !important;
    min-width: 1820px !important;
    max-width: 1820px !important;
    transform-origin: top left !important;
    zoom: 1 !important;
  }

@media (max-width: 700px) {
    .nav{
      min-height: 64px !important;
      height: auto !important;
      padding: 14px !important;
      align-items: center !important;
    }

    .nav nav{
      gap: 10px !important;
      flex-wrap: wrap !important;
      justify-content: flex-end !important;
    }

    .nav nav button, .brand-text{
      font-size: 14px !important;
    }

    .page-transition{
      padding-top: 64px !important;
    }

    /* HOME: separate mobile layout */
    .home-intro{
      height: calc(100vh - 64px) !important;
      min-height: calc(100vh - 64px) !important;
    }

    .final-text-mask{
      left: 18px !important;
      right: 18px !important;
      width: auto !important;
      overflow: hidden !important;
    }

    .final-name{
      width: 100% !important;
      max-width: 100% !important;
      font-size: clamp(26px, 9.5vw, 36px) !important;
      line-height: .84 !important;
      letter-spacing: -.03em !important;
      white-space: nowrap !important;
      padding-left: 0 !important;
    }

    .home-description{
      height: auto !important;
      min-height: 0 !important;
      padding: 34px 18px !important;
      overflow: visible !important;
    }

    .home-description-grid{
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 28px !important;
      height: auto !important;
    }

    .home-models-placeholder, .home-studio-photo{
      width: 100% !important;
      height: auto !important;
      max-height: none !important;
    }

    .home-studio-photo{
      object-fit: contain !important;
    }

    /* WORKBOOK: separate mobile layout, Sketchbook always last */
    .page-wrap, .workbook, .detail, .about{
      padding-left: 18px !important;
      padding-right: 18px !important;
    }

    .project-grid{
      display: flex !important;
      flex-direction: column !important;
      gap: 24px !important;
    }

    .project-column{
      display: contents !important;
    }

    .project-tile{
      order: 0;
      width: 100% !important;
      max-width: 100% !important;
    }

    .project-id-3{
      order: 999 !important;
    }

    /* ABOUT: separate mobile layout */
    .about{
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: 42px !important;
      padding-top: 36px !important;
      padding-bottom: 76px !important;
    }

    .about-image, .about-copy{
      width: 100% !important;
      min-width: 0 !important;
    }

    .about-video-frame{
      width: min(100%, 430px) !important;
      height: auto !important;
      aspect-ratio: 9 / 16 !important;
      margin: 0 auto !important;
    }

    .page-logo-about{
      margin-top: 84px !important;
    }

    /* Mobile typography: normal flow, no collision. */
    .home-description h1, .project-detail-title, .about-page-title, .section-heading h1{
      position: static !important;
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      margin: 0 0 18px !important;
      padding: 0 !important;
      white-space: normal !important;
      overflow: visible !important;
      font-size: clamp(28px, 8vw, 38px) !important;
      line-height: 1.08 !important;
      letter-spacing: -.02em !important;
      overflow-wrap: break-word !important;
    }

    .eyebrow, .project-eyebrow, .eyebrow-home, .eyebrow-workbook, .contact-heading-blue{
      position: static !important;
      display: block !important;
      width: 100% !important;
      height: auto !important;
      margin: 0 0 10px !important;
      padding: 0 !important;
      line-height: 1.25 !important;
      white-space: normal !important;
    }

    .home-description-copy, .detail-intro, .about-copy, .venice-sketch-caption, .contact-intro{
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      height: auto !important;
      overflow: visible !important;
    }

    .home-description-copy p, .detail-intro p:not(.eyebrow), .about-copy p, .venice-sketch-caption p, .contact-intro{
      position: static !important;
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      margin: 0 0 14px !important;
      padding: 0 !important;
      white-space: normal !important;
      overflow: visible !important;
      font-size: 13.5px !important;
      line-height: 1.55 !important;
      letter-spacing: 0 !important;
      overflow-wrap: break-word !important;
    }

    /* PROJECT PAGES: readable mobile text, desktop image composition scaled as one unit */
    .project-image-master-shell{
      width: 1240px !important;
      max-width: none !important;
      margin: 0 !important;
      overflow: visible !important;
    }

    .project-image-master-shell .detail-images{
      width: 100% !important;
      max-width: none !important;
    }

    .project-image-master-shell .detail-image-cell{
      min-width: 0 !important;
    }

    /* Sketchbook gallery remains a normal mobile gallery */
    .sketchbook-page .sketch-grid{
      grid-template-columns: 1fr !important;
      gap: 34px !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .sketchbook-page .sketch-item, .sketchbook-page .sketch-item:nth-child(12){
      width: 100% !important;
      max-width: 100% !important;
    }

    .workbook-loader{
      inset: 64px 0 0 !important;
    }
  }

  @media (max-width: 430px) {
    .final-name{
      font-size: clamp(24px, 8.8vw, 32px) !important;
    }

    .home-description h1, .project-detail-title, .about-page-title, .section-heading h1{
      font-size: 30px !important;
      line-height: 1.1 !important;
    }

    .home-description-copy p, .detail-intro p:not(.eyebrow), .about-copy p, .venice-sketch-caption p, .contact-intro{
      font-size: 13px !important;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .detail-image-cell{
      opacity: 1 !important;
      transform: none !important;
      transition: none !important;
    }

    .home-scroll-arrow{
      animation: none !important;
    }
  }

  /* ================================================================
     MOBILE HOME ANIMATION
     Exact desktop animation geometry, uniformly scaled as one object.
     ================================================================ */
  @media (max-width: 700px) {
    .home-intro{
      overflow: hidden !important;
    }

    .final-animation-layer{
      width: 100% !important;
      max-width: 100% !important;
      overflow: hidden !important;
    }

    .final-animation-stage{
      width: 1180px !important;
      min-width: 1180px !important;
      max-width: 1180px !important;
      left: auto !important;
      right: auto !important;
      margin: 0 auto !important;
    }

    /* Do not alter any of the desktop logo/name proportions on mobile. */
    .final-logo{
      width: auto !important;
      max-width: none !important;
    }

    .final-text-mask{
      top: 29% !important;
      bottom: 6% !important;
      left: 50% !important;
      right: 0 !important;
      width: auto !important;
      max-width: none !important;
    }

    .final-name{
      width: auto !important;
      max-width: none !important;
      height: 67.69% !important;
      padding-left: var(--name-gap) !important;
      font-size: 138px !important;
      line-height: .74 !important;
      letter-spacing: -.045em !important;
      white-space: nowrap !important;
    }
  }

  /* ================================================================
     FINAL TWO FIXES
     ================================================================ */

  /* Smaller laptops: never crop the Home "Designer focused on..." title
     or the body copy. Let this section grow naturally instead of clipping. */
  @media (min-width: 701px) and (max-width: 1400px) {
    .home-description{
      height: auto !important;
      min-height: calc(100vh - 76px) !important;
      overflow: visible !important;
      padding-top: 56px !important;
      padding-bottom: 56px !important;
      align-items: flex-start !important;
    }

    .home-description-grid{
      height: auto !important;
      min-height: 0 !important;
      align-items: start !important;
    }

    .home-description-grid > div:first-child, .home-description-copy{
      height: auto !important;
      min-height: 0 !important;
      overflow: visible !important;
    }

    .home-description h1{
      margin-top: 0 !important;
      overflow: visible !important;
    }

    .home-description-copy p:last-child{
      margin-bottom: 0 !important;
    }
  }

  /* Mobile: keep the exact desktop title animation, but scale the whole
     1180px animation stage down as a single object to fit the phone width. */
  @media (max-width: 700px) {
    .home-intro{
      overflow: hidden !important;
    }

    .final-animation-layer{
      width: 100% !important;
      max-width: 100% !important;
      overflow: hidden !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .final-animation-stage{
      width: 1180px !important;
      min-width: 1180px !important;
      max-width: 1180px !important;
      height: min(72vh, 620px) !important;
      flex: 0 0 1180px !important;
      transform-origin: center center !important;
      transform: scale(calc((100vw - 36px) / 1180)) !important;
    }

    .final-logo{
      width: auto !important;
      max-width: none !important;
    }

    .final-text-mask{
      top: 29% !important;
      bottom: 6% !important;
      left: 50% !important;
      right: 0 !important;
      width: auto !important;
      max-width: none !important;
      overflow: hidden !important;
    }

    .final-name{
      width: auto !important;
      max-width: none !important;
      height: 67.69% !important;
      padding-left: var(--name-gap) !important;
      font-size: 138px !important;
      line-height: .74 !important;
      letter-spacing: -.045em !important;
      white-space: nowrap !important;
    }

    .final-animation-stage.text-revealed .final-name{
      transform: translateY(5%) translateX(0) !important;
    }
  }

  /* Mobile About video: explicitly centred in the page. */
  @media (max-width: 700px) {
    .about-image{
      width: 100% !important;
      display: flex !important;
      justify-content: center !important;
      align-items: flex-start !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .about-video-frame{
      margin-left: auto !important;
      margin-right: auto !important;
      left: auto !important;
      right: auto !important;
    }
  }

  /* Mobile title animation: give the text more headroom so Wilf is not clipped. */
  @media (max-width: 700px) {
    .final-text-mask{
      top: 24% !important;
      bottom: 6% !important;
    }

    .final-name{
      height: 72% !important;
      overflow: visible !important;
    }
  }

  /* Mobile title sequence: preserve the animation and scale, but expand the
     clipping window upward so every part of Wilf Edwards remains visible. */
  @media (max-width: 700px) {
    .final-text-mask{
      top: 18% !important;
      bottom: 4% !important;
      overflow: hidden !important;
    }

    .final-name{
      height: 78% !important;
      overflow: visible !important;
    }
  }

  @media (max-width: 430px) {
    .final-text-mask{
      top: 16% !important;
      bottom: 3% !important;
    }

    .final-name{
      height: 81% !important;
    }
  }

  /* ================================================================
     GLOBAL TITLE-SEQUENCE CLIPPING FIX
     Preserve the animation and scale, but enlarge the vertical clipping
     window so all of Wilf Edwards is visible on every device.
     ================================================================ */
  .final-text-mask{
    top: 16% !important;
    bottom: 1% !important;
    overflow: hidden !important;
  }

  .final-name{
    height: 83% !important;
    overflow: visible !important;
  }

  @media (max-width: 700px) {
    .final-text-mask{
      top: 10% !important;
      bottom: 0 !important;
    }

    .final-name{
      height: 90% !important;
    }
  }

  /* Mobile title sequence: halve the vertical gap between Wilf and Edwards. */
  @media (max-width: 700px) {
    .final-name{
      justify-content: center !important;
      gap: 0.42em !important;
    }
  }

  @media (max-width: 430px) {
    .final-name{
      gap: 0.36em !important;
    }
  }

  /* Mobile project-page titles: never clip vertically. */
  @media (max-width: 700px) {
    .detail-intro{
      overflow: visible !important;
      height: auto !important;
      min-height: 0 !important;
    }

    .project-detail-title{
      position: static !important;
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      overflow: visible !important;
      white-space: normal !important;
      line-height: 1.12 !important;
      padding-top: 0.08em !important;
      padding-bottom: 0.16em !important;
      margin-top: 0 !important;
      margin-bottom: 18px !important;
    }
  }

  /* Mobile project Back control: black, including hover/active states. */
  @media (max-width: 700px) {

    /* Mobile project titles: fit fully within the viewport. */
    .detail-intro{
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      overflow: visible !important;
    }

    .project-detail-title{
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box !important;
      white-space: normal !important;
      overflow: visible !important;
      overflow-wrap: anywhere !important;
      word-break: normal !important;
      padding-right: 0 !important;
      margin-right: 0 !important;
      font-size: clamp(28px, 8vw, 36px) !important;
      line-height: 1.08 !important;
      letter-spacing: -0.015em !important;
    }
  }

  /* Mobile project titles: smaller, contained, with deliberate breaks on long names. */
  .project-title-mobile{
    display: none;
  }

  @media (max-width: 700px) {
    .project-title-desktop{
      display: none !important;
    }

    .project-title-mobile{
      display: inline !important;
    }

    .project-detail-title{
      font-size: clamp(24px, 6.8vw, 31px) !important;
      line-height: 1.12 !important;
      letter-spacing: -0.01em !important;
      width: 100% !important;
      max-width: 100% !important;
      white-space: normal !important;
      overflow: visible !important;
      overflow-wrap: normal !important;
      word-break: normal !important;
    }

    /* Keep the current scale; move the whole title-sequence lockup slightly left. */
    .final-animation-stage{
      margin-left: -10px !important;
    }
  }

  @media (max-width: 430px) {
    .project-detail-title{
      font-size: clamp(23px, 6.5vw, 29px) !important;
    }

    .final-animation-stage{
      margin-left: -8px !important;
    }
  }

  /* Mobile About: wider text block and tighter spacing to the video. */
  @media (max-width: 700px) {
    .about{
      gap: 18px !important;
      padding-top: 24px !important;
      padding-bottom: 54px !important;
    }

    .about-image{
      margin-bottom: 0 !important;
      padding-bottom: 0 !important;
    }

    .about-copy{
      width: 100% !important;
      max-width: 100% !important;
      padding-top: 0 !important;
      margin-top: 0 !important;
    }

    .about-copy .contact-intro, .about-copy p{
      width: 100% !important;
      max-width: none !important;
    }

    .about-page-title{
      margin-top: 0 !important;
      margin-bottom: 14px !important;
    }

    .about-columns{
      margin-top: 18px !important;
    }

    .page-logo-about{
      margin-top: 42px !important;
    }
  }

  @media (max-width: 430px) {
    .about{
      gap: 14px !important;
      padding-top: 20px !important;
    }

    .about-page-title{
      margin-bottom: 12px !important;
    }

    .about-columns{
      margin-top: 14px !important;
    }

    .page-logo-about{
      margin-top: 34px !important;
    }
  }

  /* Mobile: move the whole title-sequence lockup further left, scale unchanged. */
  @media (max-width: 700px) {
    .final-animation-stage{
      margin-left: -24px !important;
    }

    .project-detail-title{
      font-size: clamp(21px, 5.8vw, 27px) !important;
      line-height: 1.12 !important;
      max-width: 100% !important;
      width: 100% !important;
    }
  }

  @media (max-width: 430px) {
    .final-animation-stage{
      margin-left: -20px !important;
    }

    .project-detail-title{
      font-size: clamp(20px, 5.4vw, 25px) !important;
    }
  }

  /* ================================================================
     MOBILE EMBEDDED-PAGE TITLES
     One consistent title treatment for every page opened from Workbook.
     ================================================================ */
  @media (max-width: 700px) {
    .detail .project-detail-title, .sketchbook-page .project-detail-title, .sketch-detail .project-detail-title, .detail-intro h1, .sketchbook-page .detail-intro h1{
      display: block !important;
      position: static !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      height: auto !important;
      margin: 0 0 18px !important;
      padding: 0 !important;
      text-align: left !important;
      font-size: 24px !important;
      line-height: 1.12 !important;
      letter-spacing: -0.01em !important;
      white-space: normal !important;
      overflow: visible !important;
      overflow-wrap: normal !important;
      word-break: normal !important;
    }

    .project-title-mobile, .project-title-desktop{
      text-align: left !important;
    }
  }

  @media (max-width: 430px) {
    .detail .project-detail-title, .sketchbook-page .project-detail-title, .sketch-detail .project-detail-title, .detail-intro h1, .sketchbook-page .detail-intro h1{
      font-size: 22px !important;
      line-height: 1.14 !important;
    }
  }

  /* Mobile Sketchbook: align all text to the same left edge as the page. */
  @media (max-width: 700px) {
    .sketchbook-page .detail-intro, .sketchbook-page .detail-intro > *, .sketchbook-page .eyebrow, .sketchbook-page .project-detail-title, .sketchbook-page .detail-intro p{
      width: 100% !important;
      max-width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      text-align: left !important;
      justify-self: start !important;
      align-self: start !important;
    }

    .sketchbook-page .detail-intro{
      display: block !important;
    }
  }

  /* ================================================================
     MOBILE: SKETCHBOOK BACK + SKETCH STUDY IMAGE FIT
     ================================================================ */
  @media (max-width: 700px) {
    /* Sketchbook Back control: black and flush with the page's left edge. */

    /* Sketch Study pages: make the image fit fully within the phone width. */
    .sketch-detail, .venice-sketch-detail{
      width: 100% !important;
      max-width: 100% !important;
      overflow-x: hidden !important;
    }

    .venice-sketch-frame{
      width: 100% !important;
      max-width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      overflow: hidden !important;
    }

    .venice-sketch-frame img{
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      height: auto !important;
      object-fit: contain !important;
      margin: 0 auto !important;
      transform: none !important;
    }
  }

  /* Small laptops: keep the inverted About-video logo safely inside the frame. */
  @media (min-width: 701px) and (max-width: 1400px) {
    .about-video-logo{
      bottom: 6% !important;
    }
  }

  /* Hide browser scrollbars on every page/device while preserving scrolling. */
  html, body, #root, .site{
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  html::-webkit-scrollbar, body::-webkit-scrollbar, #root::-webkit-scrollbar, .site::-webkit-scrollbar, *::-webkit-scrollbar{
    width: 0 !important;
    height: 0 !important;
    display: none !important;
  }

  /* ================================================================
     GLOBAL SCROLLBAR REMOVAL
     Hide visible scrollbars everywhere while preserving scrolling.
     ================================================================ */
  html, body, #root, .site, .page-wrap, .detail, .gallery, .about, .workbook, .desktop-master-viewport{
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
  }

  html::-webkit-scrollbar, body::-webkit-scrollbar, #root::-webkit-scrollbar, .site::-webkit-scrollbar, .page-wrap::-webkit-scrollbar, .detail::-webkit-scrollbar, .gallery::-webkit-scrollbar, .about::-webkit-scrollbar, .workbook::-webkit-scrollbar, .desktop-master-viewport::-webkit-scrollbar, *::-webkit-scrollbar{
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    background: transparent !important;
  }

  html, body{
    overflow-x: hidden !important;
  }

  /* Projects heading helper copy. */
  .projects-subheading{
    margin: 10px 0 0 !important;
    max-width: 620px;
    font-family: "Univers Light", sans-serif;
    font-weight: 300;
    font-size: 16px;
    line-height: 1.4;
    color: ${COLORS.black};
  }

  /* Park Crescent caption: preserve visible word spaces and give the line
     a little more breathing room without changing any other sketch caption. */
  .park-crescent-caption{
    margin-top: 10px !important;
  }

  .park-crescent-caption p{
    word-spacing: 0.08em !important;
  }

  /* Persistent Back control for project, Sketch Study and Sketchbook pages.
     Fixed positioning is used so it remains available while scrolling even inside the
     scaled desktop canvas. */

  @media (max-width: 700px) {
    .projects-subheading{
      width: 100% !important;
      max-width: 100% !important;
      font-size: 14px !important;
    }
  }

  /* ================================================================
     SINGLE PERSISTENT BACK CONTROL
     One dedicated right-side channel, outside project/sketch imagery.
     ================================================================ */
  .detail-back-channel{
    position: fixed !important;
    right: 0 !important;
    width: auto !important;
    height: 24px !important;
    z-index: 18 !important;
    display: flex !important;
    align-items: flex-start !important;
    justify-content: center !important;
    pointer-events: none !important;
    background: transparent !important;
  }

  .detail-back-control{
    pointer-events: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    outline: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    color: #b8b8b8 !important;
    font-family: "Univers Light", sans-serif !important;
    font-weight: 300 !important;
    font-size: 13px !important;
    line-height: 1 !important;
    text-decoration: none !important;
    white-space: nowrap !important;
    cursor: pointer !important;
    transition: color 160ms ease !important;
  }

  .detail-back-control:hover, .detail-back-control:focus-visible{
    color: ${COLORS.black} !important;
    border: 0 !important;
    text-decoration: none !important;
  }

  @media (max-width: 700px) {
    .detail-back-channel{
      right: 0 !important;
      background: ${COLORS.white} !important;
    }

    .detail-view-open .detail, .detail-view-open .sketch-detail, .detail-view-open .venice-sketch-detail, .detail-view-open .sketchbook-page{
      padding-right: 70px !important;
    }

    .sketchbook-single-page{
      height: calc(100dvh - 76px);
      min-height: calc(100dvh - 76px);
      padding: 0 70px 0 0;
    }

    .sketchbook-single-frame{
      padding: 18px;
    }

    .detail-back-control{
      font-size: 12px !important;
    }
  }

`;